import React from 'react'
import moment from 'moment'
import ReactModal from 'react-modal'
import _ from 'lodash'
import NavigationBar from '../Commons/NavigationBar'
import RadioGroup from 'react-radio-group'
import { ToastContainer, ToastMessage } from 'react-toastr'
import HSeparator from '../../img/commons/hseparator.png'
import * as request from 'superagent'
import lock from '../../img/icons/general-icons/icon_lock.png'
import unlock from '../../img/icons/general-icons/icon_unlock.png'
import SkyLight from 'react-skylight'
import warningData from '../../img/icons/general-icons/icon_warning.png'
import DefaultPicture from '../../img/commons/default_picture.png'
import { verifyAuth, getToken } from '../Commons/Authentication'
import Rslider from '../Commons/RangeSlider'
import { hashHistory } from 'react-router'
import MiddleLine from '../../img/icons/general-icons/separator_icon.png'
import closeModal from '../../img/icons/general-icons/close.png'
import DirtyFunction from './DirtyFunction'
import ProcessAllTabs from './ProcessAllTabs'
import SeudoSelect from './SeudoSelect'
import '../../css/components/health.css'
import ReadHealth from './ReadHealth'
import ValidateParameters, { ValidateShowModal } from './ValidateParameters'
const ToastMessageFactory = React.createFactory(ToastMessage.animation)
export default class HealthForm extends React.Component {
  arr() {
    let arr = []
    for (var e = 0; e < 26; e++) {
      arr.push('data-input')
    }
    return arr
  }
  constructor(props) {
    super(props)


    this.state = {
      modal: false,
      classNamecoltotal: 'hide',
      classNamecolldl: 'hide',
      classNamecolhdl: 'hide',
      classNamecreatinina: 'hide',
      classNametrigliceridos: 'hide',
      classNameglicemia: 'hide',
      classNamepeso: 'hide',
      classNamepaparado: 'hide',
      classNamepaparado_n: 'hide',
      classNamepsentado: 'hide',
      classNamepsentado_n: 'hide',
      classNamefrecuencia: 'hide',
      classNamealtura: 'hide',
      numeroDocumento: '',
      dataPrograma: [],
      dataAsegurador: [],
      selectedValue: 'No',
      ansdepSelectedValue: '',
      dmSelectedValue: '',
      actcoSelectedValue: '',
      cpSelectedValue: '',
      movSelectedValue: '',
      phySelectedValue: '',
      movText: '',
      cpText: '',
      dataActivity: [],
      ansdepText: '',
      actcoText: '',
      ppaText: '',
      ppbText: '',
      psaText: '',
      psbText: '',
      imc: '',
      asegurador: '',
      aseguradorId: '',
      prestacion: '',
      prestacionId: '',
      programa: '',
      programaId: '',
      coltText: '',
      colLDLText: '',
      colHDLText: '',
      triText: '',
      creText: '',
      gliText: '',
      dmText: '',
      imcCalc: '',
      medicalData: { mets: 0 },
      decSelectedValue: '',
      happinessSelectedValue: '',
      transcendenceSelectedValue: '',
      worriedSelectedValue: '',
      satisfiedSelectedValue: '',
      presionParadoAlta: '',
      presionParadoBaja: '',
      presionSentadoAlta: '',
      presionSentadoBaja: '',
      frecuencia: '',
      temperatura: '',
      grasaCorporal: '',
      peso: '',
      altura: '',
      funcional: '',
      pabdominal: '',
      vop: '',
      itbi: '',
      itbd: '',
      balanceNeuroIMuscular: '',
      balanceNeuroDMuscular: '',
      gripi: '',
      gripd: '',
      tiempoCincoM: '',
      health: '',
      colesterolTotal: '',
      colesterolLDL: '',
      colesterolHDL: '',
      trigliceridos: '',
      creatinina: '',
      glicemia: '',
      dirty: false,
      patientData: {},
      patientImage: '',
      patientFullName: '',
      patientDocumentNumb: '',
      patientAge: '',
      patientIndetificationDoc: '',
      patientCreatedTime: '',
      patientDiabetico: '',
      patientGender: '',
      crclass: 'medical-inputs',
      ctclass: 'medical-inputs',
      clclas: 'medical-inputs',
      chclass: 'medical-inputs',
      paclass: 'medical-inputs',
      psclass: 'medical-inputs',
      notasText: '',
      createdDate: '',
      basicUnlockSymbol: '',
      emotiUnlockSymbol: '',
      activUnlockSymbol: '',
      physiUnlockSymbol: '',
      examnUnlockSymbol: '',
      diabeUnlockSymbol: '',
      positionMedical: '',
      patient: '',
      readMode: 'health-content-show hide',
      editionMode: 'health-content',
      disableInputsState: false,
      incPass: '',
      errorMessage: '',
      control: '',
      duracionDm: '',
      hba1c: '',
      fevi: '',
      fase: '',
      funcional: '',
      pieDiabeValue: '',
      selectedAlb: '',
      IAMValue: '',
      ICCValue: '',
      ACVValue: '',
      AngPrev: '',
      ojosValue: '',
      corazonValue: '',
      rinonValue: '',
      neuroValue: '',
      cerebroValue: '',
      vascularValue: '',
      metabValue: '',
      inpErrorClass: 'input-password-confirm',
      IMCRange: '',
      perAbdRange: '',
      presArRange: '',
      presPRange: '',
      presSRange: '',
      vopRange: '',
      fcRange: '',
      itbiRange: '',
      itbdRange: '',
      coltRange: '',
      movRange: '',
      dolRange: '',
      ansRange: '',
      actRange: '',
      cupRange: '',
      metsRange: '',
      satRange: '',
      preRange: '',
      conRange: '',
      depRange: '',
      felRange: '',
      trigRange: '',
      collRange: '',
      colhRange: '',
      hba1cRange: '',
      albuRange: '',
      creatRange: '',
      balIzRange: '',
      balDeRange: '',
      indViRange: '',
      indCaRange: '',
      resFnRange: '',
      balAfRange: '',
      edadARange: '',
      edadBRange: '',
      ojosERange: '',
      rinonRange: '',
      neuroRange: '',
      metabRange: '',
      corazRange: '',
      cerebRange: '',
      vascuRange: '',
      hospiRange: '',
      superRange: '',
      duraDRange: '',
      tabaqRange: '',
      iamRange: '',
      iccRange: '',
      acvRange: '',
      angRange: '',
      sistolicaRange: '',
      clasFRange: '',
      clasSRange: '',
      feviVRange: '',
      evaPDRange: '',
      overlymain: 'hide',
      hba1cClass: 'severity-input',
      all: {},
      currentRol: '',
      timeClass: 'severity-input',
      showAddControl: true,
      medicalsCore2: {},
      arr: this.arr()
    }
    this.saving = false
  }
  goTabla() {
    var url = "/#/tabledata/" + this.props.params.patient;
    window.location.href = url;
    console.log("e");
  }
  componentWillMount() {
    this.findPatientData()
    this.loadUserData()
  }
  handleDelete(e) {
    console.log('click', e.currentTarget.dataset.value, e.target.id)
  }
  loadUserData() {
    let endpoint = 'api/v1/user/find'
    request
      .get(endpoint)
      .set('Authorization', `Bearer ${getToken()}`)
      .set('Accept', 'application/json')
      .end((err, res) => {
        if (err) console.log('nologueado')
        else {
          if (!res.body.rol) {
            this.setState({ moduleDiabetes: false, moduleMedical: false })
          } else if (!res.body.rol[0]) {
            this.setState({ moduleDiabetes: false, moduleMedical: false })
          } else {
            if (res.body.rol[0].nombre) {
              if (
                res.body.rol[0].nombre === 'admin' ||
                res.body.rol[0].nombre === 'medico_sicor'
              ) {
                let asegurador = res.body.rol[0].nombre == 'general sura' ? 'EPS Sura' : ''
                let aseguradorId = res.body.rol[0].nombre == 'general sura' ? '57c4955b2171fa5b2490d159' : ''
                let programa = res.body.rol[0].nombre == 'general sura' ? 'Saludable' : ''
                let programaId = res.body.rol[0].nombre == 'general sura' ? '5cec58e00631573619d54a83' : ''
                let prestacionId = res.body.rol[0].nombre == 'general sura' ? '5e6a91e547828d567a2e9002' : ''
                let prestacion = res.body.rol[0].nombre == 'general sura' ? 'CF IPS Bello' : ''

                this.setState({
                  moduleMedical: true,
                  currentRol: res.body.rol[0].nombre,
                  asegurador,
                  aseguradorId,
                  programa,
                  programaId,
                  prestacionId,
                  prestacion
                })
              } else if (res.body.rol[0].nombre === 'enfermero') {
                this.setState({
                  moduleMedical: false,
                  currentRol: res.body.rol[0].nombre
                })
              }
            }
          }
        }
      })
  }
  findPatientData() {
    let endpoint = `api/v1/patient/find?numeroDocumento=${
      this.props.params.patient
      }`
    request
      .get(endpoint)
      .set('Authorization', `Bearer ${getToken()}`)
      .set('Accept', 'application/json')
      .end((err, res) => {
        if (!_.isEmpty(res.body[0])) {
          let patientInfo = res.body[0]
          var birthday = new Date(
            patientInfo.fechaNacimiento
              .split('/')
              .reverse()
              .join('-')
          )
          var ageDifMs = Date.now() - birthday.getTime()
          var ageDate = new Date(ageDifMs)
          var age = Math.abs(ageDate.getUTCFullYear() - 1970)
          var date_muerte = moment(patientInfo.date_muerte).format(
            'DD-MM-YYYY'
          )
          var image = patientInfo.image ? patientInfo.image : DefaultPicture

          this.setState({
            patientId: patientInfo._id,
            patientBirthday: patientInfo.fechaNacimiento,
            patientIdentificationDoc:
              patientInfo.tipoDocumento + ' ' + patientInfo.numeroDocumento,
            patientImage: image,
            patientGender: patientInfo.genero,
            promedioSistolica: '',
            patientFullName: `${patientInfo.nombres} ${patientInfo.apellidos}`,
            patientAge: age,
            patientGender: patientInfo.genero,
            patientDiabetico: patientInfo.diabetico,
            patientCreatedTime: patientInfo.timestamp,
            muerto: patientInfo.muerto,
            date_muerte: date_muerte
          }, () => {
            this.loadMedicalControlTabs()
            this.findHealthData()
          })
        } else {
          // console.log('Error: ' + err)
        }
      })
  }
  mesesFinishDate(meses, arr) {
    console.log(meses, arr)
  }
  findCore2Data() {
    let identificacion = this.props.params.patient
    // let date = (this.state.createdDate == '' || this.state.createdDate == null || typeof this.state.createdDate == 'undefined' ) ? this.state.patientCreatedTime : this.state.createdDate
    let date = this.state.timestamp
      ? this.state.timestamp
      : moment().format('x')
    request
      .get('api/v1/appointment/')
      .query({ identificacion: identificacion, TIMESTAMP: date })
      .set('Authorization', 'Bearer ' + getToken())
      .set('Accept', 'application/json')
      .end((err, res) => {
        if (err || !res.ok) {
          console.log('appointment response error')
        } else {
          // console.log('appointment response ', res.body)
          try {
            if (res.body.Message) {
            } else {
              delete res.body._id
              var newArray = this.state
              if (res.body.TIMESTAMP * 1000 < this.state.timestamp) return
              let d = _.merge(newArray, res.body)
              console.log(res.body)
              let arr = d.arr
              let meses = moment().diff(
                moment(d.TIMESTAMP * 1000, 'x'),
                'months'
              )
              if (meses < 3) {
                arr[0] = 'data-input'
                arr[1] = 'data-input'
                arr[2] = 'data-input'
                arr[3] = 'data-input'
                arr[4] = 'data-input'
                arr[5] = 'data-input'
                arr[6] = 'data-input'
                arr[15] = 'data-input'
                arr[16] = 'data-input'
                arr[17] = 'data-input'
                arr[18] = 'data-input'
                arr[19] = 'data-input'
                arr[20] = 'data-input'
                arr[21] = 'data-input'
                arr[22] = 'data-input'
                arr[23] = 'data-input'
                arr[24] = 'data-input'
                arr[25] = 'data-input'
              }
              d.arr = arr
              this.setState(d)
            }
          } catch (e) {
            throw e
          }
        }
      })
  }

  lockEdition(timestamp, disable) {
    let dayDif = moment().diff(moment(timestamp, 'x').format(), 'hours')
    let lockImage = dayDif >= 12 ? lock : unlock
    let position = dayDif >= 12 ? 'absolute' : ''
    let disabledInpt = dayDif >= 12 ? true : false
    if (disable) {
      lockImage = ''
    }
    this.setState({
      basicUnlockSymbol: lockImage,
      emotiUnlockSymbol: lockImage,
      activUnlockSymbol: lockImage,
      physiUnlockSymbol: lockImage,
      examnUnlockSymbol: lockImage,
      diabeUnlockSymbol: lockImage,
      notesUnlockSymbol: lockImage,
      positionPhysical: position,
      positionExamns: position,
      positionDiabetes: position,
      positionActivity: position,
      positionEmotional: position,
      positionMedical: position,
      positionNotes: position,
      disableInputsState: disabledInpt
    })
  }
  mesesFinish(meses) {
    let monthsFinished = []
    for (var o = 0; o < 25; o++) {
      if (meses >= 3) {
        monthsFinished.push('data-input red')
      } else {
        monthsFinished.push('data-input')
      }
    }
    if (meses >= 3) {
      this.refs.container.error(
        'Los campos de texto en rojo tienen más de 3 meses de antigüedad, actualizar datos.',
        '',
        {
          closeButton: true,
          timeOut: 30000
        }
      )
    }
    return monthsFinished
  }
  findHealthData() {
    let headers = { 'Content-Type': 'application/json' }
    headers['Authorization'] = `Bearer ${getToken()}`
    fetch(`api/v1/estadoSalud/paciente/${this.state.patientId}/ultimoEstadoSalud`, { method: 'Get', headers })
      .then((res) => {
        return res.json()
      }).then((res) => {
        //debugger
        console.warn("\n Habia debugger \n")
        if (res['_id']) {
          this.lockEdition(res.timestamp, false)
          //
          this.setState({
            presionSentadoBaja: res['diastoleSentado'], presionParadoBaja: res['diastoleParado'], presionSentadoAlta: res['sistoleSentado'], presionParadoAlta: res['sistoleParado'], pabdominal: res['perimetroAbdominal'], balanceNeuroIMuscular: res['balanceNeuroMuscularIzquierdo'], balanceNeuroDMuscular: res['balanceNeuroMuscularDerecho'], gripi: res['gripi'], gripd: res['gripd'], itbi: res['itbIzquierdo'], itbd: res['itbDerecho'], imc: res['imc'], vop: res['vop'], notasText: res['notas'], frecuencia: res['frecuencia'], tiempoCincoM: res['tiempoCincoM'], medicalData: res, prestacion: res['prestacion'], prestacionId: res['prestacionId'], programa: res['programa'], programaId: res['programaId'], asegurador: res['asegurador'], aseguradorId: res['aseguradorId'], patientGender: res['gender'], peso: res['peso'], altura: res['altura'], patientBirthday: res['fechaNacimiento'], health: res['salud'], temperatura: res['temperatura'],
            grasaCorporal: res['grasaCorporal'],
            patientId: res['paciente'], currentId: res['_id']
          })
        } else {
          let { arr } = this.state
          arr = arr.map(() => 'data-input red')
          this.setState({ arr })
        }
      })
  }

  smokeSelection(value) {

    let newMedicalData = this.state.medicalData
    newMedicalData.fuma = value
    this.setState({ medicalData: newMedicalData, dirty: true })
  }

  phySelection(value) {
    let newMedicalData = this.state.medicalData
    newMedicalData.mets = value
    this.setState({ medicalData: newMedicalData, dirty: true })
    let phyArray = [
      ' ',
      'Inactivo o poca actividad distinta a las actividades cotidianas',
      'Participación en actividades, 2 a 5 veces por semana, que requieren pequeños esfuerzos que resultan en leves incrementos en la respiración y el ritmo cardiaco por al menos diez minutos cada vez.',
      'Aeróbicos como caminar con energía, trotar o correr, montar bicicleta, nadar o practicar un deporte vigoroso por: 20 a 60 minutos por semana.',
      'Aeróbicos como caminar con energía, trotar o correr, montar bicicleta, nadar o practicar un deporte vigoroso por: 1 a 3 horas por semana.',
      'Aeróbicos como caminar con energía, trotar o correr, montar bicicleta, nadar o practicar un deporte vigoroso por: más de 3 horas por semana.'
    ]
    this.setState({ phyText: phyArray[value] })
  }

  movSelection(value) {
    let newMedicalData = this.state.medicalData
    newMedicalData.movilidad = value
    this.setState({ medicalData: newMedicalData, dirty: true })
    let moveArray = [
      ' ',
      'No tengo problemas para caminar',
      'Tengo algunos problemas para caminar',
      'Tengo que estar en la cama'
    ]
    this.setState({ movText: moveArray[value] })
  }

  cpSelection(value) {
    let newMedicalData = this.state.medicalData
    newMedicalData.cuidadoPersonal = value
    this.setState({ medicalData: newMedicalData, dirty: true })
    let cpArray = [
      ' ',
      'No tengo problemas con el cuidado personal',
      'Tengo algunos problemas para lavarme o vestirme',
      'Soy incapaz de lavarme o vestirme'
    ]
    this.setState({ cpText: cpArray[value] })
  }

  ansdepSelection(value) {
    let newMedicalData = this.state.medicalData
    newMedicalData.ansiedad = value
    this.setState({ medicalData: newMedicalData, dirty: true })
    let ansdepArray = [
      ' ',
      'No estoy ansioso ni deprimido',
      'Estoy moderadamente ansioso o deprimido',
      'Estoy muy ansioso o deprimido'
    ]
    this.setState({ ansdepText: ansdepArray[value] })
  }

  actcoSelection(value) {
    let newMedicalData = this.state.medicalData
    newMedicalData.actividadesCotidianas = value
    this.setState({ medicalData: newMedicalData, dirty: true })
    let actcoArray = [
      ' ',
      'No tengo problemas para realizar mis actividades cotidianas',
      'Tengo algunos problemas para realizar mis actividades cotidianas',
      'Soy incapaz de realizar mis actividades cotidianas'
    ]
    this.setState({ actcoText: actcoArray[value] })
  }

  dmSelection(value) {
    let newMedicalData = this.state.medicalData
    newMedicalData.dolor = value
    this.setState({ medicalData: newMedicalData, dirty: true })
    let dmArray = [
      ' ',
      'No tengo dolor ni malestar',
      'Tengo moderado dolor o malestar',
      'Tengo mucho dolor o malestar'
    ]
    this.setState({ dmText: dmArray[value] })
  }

  satisfiedSelection(value) {
    let newMedicalData = this.state.medicalData
    newMedicalData.satisfaccion = value
    this.setState({ medicalData: newMedicalData, dirty: true })
  }

  happinessSelection(value) {
    let newMedicalData = this.state.medicalData
    newMedicalData.feliz = value
    this.setState({ medicalData: newMedicalData, dirty: true })
  }

  transcendenceSelection(value) {
    let newMedicalData = this.state.medicalData
    newMedicalData.depresion = value
    this.setState({ medicalData: newMedicalData, dirty: true })
  }

  worriedSelection(value) {
    let newMedicalData = this.state.medicalData
    newMedicalData.preocupacion = value
    this.setState({ medicalData: newMedicalData, dirty: true })
  }

  decSelection(value) {
    let newMedicalData = this.state.medicalData
    newMedicalData.decaido = value
    this.setState({ medicalData: newMedicalData, dirty: true })
  }
  updateFunction() {

    if (this.state.dirty) {
      //console.log("\n Entra en DIRTyyyyyy..")
      let updatearray = DirtyFunction(this.state, this.state.all)
      //console.log("\n UPDATE arrayyyyy... \n", updatearray)
      let headers = { 'Content-Type': 'application/json' }
      headers['Authorization'] = `Bearer ${getToken()}`
      fetch(`api/v1/estadoSalud/${this.state.medicalData._id}`,
        { method: 'PUT', headers, body: JSON.stringify(updatearray) })
        .then((res) => res.json()).then((res) => {
          if (res) {
            this.refs.container.success('Registro Actualizado', '', { closeButton: true })
            setTimeout(() => {
              hashHistory.push('estadoSaludDashboard/' + this.props.params.patient)
            }, 1800)
          }
        })
    }
  }
  saveFunction() {
    let array = {
      'asegurador': this.state.asegurador,
      'aseguradorId': this.state.aseguradorId,
      'prestacion': this.state.prestacion,
      'prestacionId': this.state.prestacionId,
      'programa': this.state.programa,
      'programaId': this.state.programaId,
      'diastoleSentado': this.state.presionSentadoBaja,
      'diastoleParado': this.state.presionParadoBaja,
      'sistoleSentado': this.state.presionSentadoAlta,
      'sistoleParado': this.state.presionParadoAlta,
      'perimetroAbdominal': this.state.pabdominal,
      'balanceNeuroMuscularIzquierdo': this.state.balanceNeuroIMuscular,
      'balanceNeuroMuscularDerecho': this.state.balanceNeuroDMuscular,
      'gripi': this.state.gripi,
      'gripd': this.state.gripd,
      'vop': this.state.vop,
      'itbIzquierdo': this.state.itbi,
      'itbDerecho': this.state.itbd,
      'imc': this.state.imc,
      'balanceNeuroMuscularT': this.state.balanceNeuroIMuscular,
      'notas': this.state.notasText,
      'frecuencia': this.state.frecuencia,
      'tiempoCincoM': this.state.tiempoCincoM,
      'mets': this.state.medicalData.mets,
      'depresion': this.state.medicalData.depresion,
      'satisfaccion': this.state.medicalData.satisfaccion,
      'feliz': this.state.medicalData.feliz,
      'preocupacion': this.state.medicalData.preocupacion,
      'decaido': this.state.medicalData.decaido,
      'gender': this.state.patientGender,
      'peso': this.state.peso,
      'altura': this.state.altura,
      'fechaNacimiento': this.state.patientBirthday,
      'fuma': this.state.medicalData.fuma ? this.state.medicalData.fuma : 'No',
      'movilidad': this.state.medicalData.movilidad,
      'cuidadoPersonal': this.state.medicalData.cuidadoPersonal,
      'actividadesCotidianas': this.state.medicalData.actividadesCotidianas,
      'dolor': this.state.medicalData.dolor,
      'ansiedad': this.state.medicalData.ansiedad,
      'paciente': this.state.patientId,
      'salud': this.state.health,
      'temperatura': this.state.temperatura,
      'grasaCorporal': this.state.grasaCorporal,
      'versionAlgoritmo': 'v1'
    }
    let modalStatus = ValidateShowModal(array)

    try {
      if (modalStatus.Empty) {
        modalStatus.obj.map((err) => {
          setTimeout(() => {
            this.refs.container.error(err.name, '', { closeButton: true })
          }, 300)


        })
        return
      }
      else if (modalStatus.objRange) {
        if (modalStatus.objRange.length > 0) {
          //console.log(modalStatus.objRange)
          let mensajeAdvertencia = ''
          modalStatus.objRange.map((ob) => {
            mensajeAdvertencia += `El valor de ${ob.label} esta fuera de un rango aceptable, ${ob.rango}, y el valor que pusiste es ${ob.valor},`
          })
          // setTimeout(()=>{
          //   this.refs.container.info(mensajeAdvertencia, '', { closeButton: true, timeOut: 12000 }, )
          // }, 300)
          this.refs.container.warning(
            <span className="center-content">
              {mensajeAdvertencia} desea Continuar ?
              <br />
              <br />
              <span className="email-validation-container">
                <button
                  type="button"
                  className="btn btn-confirm clear"
                  onClick={this.saveForce.bind(this)}
                >
                  Si
                </button>
                <button type="button" className="btn btn-confirm clear">
                  No
                </button>
              </span>
            </span>,
            <em>Tiene cambios pendientes</em>,
            {
              closeButton: true,
              showDuration: "300",
              hideDuration: "1000",
              timeOut: 0,
              extendedTimeOut: 0,
              showEasing: "swing",
              hideEasing: "linear",
              showMethod: "fadeIn",
              hideMethod: "fadeOut"
            }
          );
        }
      }
      else {
        this.saveForce()
      }
    } catch (err) {
      console.log(err)
    }


  }
  saveForce() {
    let array = {
      'asegurador': this.state.asegurador,
      'aseguradorId': this.state.aseguradorId,
      'prestacion': this.state.prestacion,
      'prestacionId': this.state.prestacionId,
      'programa': this.state.programa,
      'programaId': this.state.programaId,
      'diastoleSentado': this.state.presionSentadoBaja,
      'diastoleParado': this.state.presionParadoBaja,
      'sistoleSentado': this.state.presionSentadoAlta,
      'sistoleParado': this.state.presionParadoAlta,
      'perimetroAbdominal': this.state.pabdominal,
      'balanceNeuroMuscularIzquierdo': this.state.balanceNeuroIMuscular,
      'balanceNeuroMuscularDerecho': this.state.balanceNeuroDMuscular,
      'gripi': this.state.gripi,
      'gripd': this.state.gripd,
      'vop': this.state.vop,
      'itbIzquierdo': this.state.itbi,
      'itbDerecho': this.state.itbd,
      'imc': this.state.imc,
      'balanceNeuroMuscularT': this.state.balanceNeuroIMuscular,
      'notas': this.state.notasText,
      'frecuencia': this.state.frecuencia,
      'tiempoCincoM': this.state.tiempoCincoM,
      'mets': this.state.medicalData.mets,
      'depresion': this.state.medicalData.depresion,
      'satisfaccion': this.state.medicalData.satisfaccion,
      'feliz': this.state.medicalData.feliz,
      'preocupacion': this.state.medicalData.preocupacion,
      'decaido': this.state.medicalData.decaido,
      'gender': this.state.patientGender,
      'peso': this.state.peso,
      'altura': this.state.altura,
      'fechaNacimiento': this.state.patientBirthday,
      'fuma': this.state.medicalData.fuma ? this.state.medicalData.fuma : 'No',
      'movilidad': this.state.medicalData.movilidad,
      'cuidadoPersonal': this.state.medicalData.cuidadoPersonal,
      'actividadesCotidianas': this.state.medicalData.actividadesCotidianas,
      'dolor': this.state.medicalData.dolor,
      'ansiedad': this.state.medicalData.ansiedad,
      'paciente': this.state.patientId,
      'salud': this.state.health,
      'temperatura': this.state.temperatura,
      'grasaCorporal': this.state.grasaCorporal,
      'versionAlgoritmo': 'v1'
    }
    let headers = { 'Content-Type': 'application/json' }
    headers['Authorization'] = `Bearer ${getToken()}`
    if (!this.saving) {
      this.saving = true
      fetch('api/v1/estadoSalud', { method: 'POST', headers, body: JSON.stringify(array) })
        .then(res => {
          return res.json()
        })
        .then((res) => {
          if (res.message !== '' && res.message) {
            this.refs.container.error(res.message, '', { closeButton: true })
            res.invalidFields.map((err) => {
              this.refs.container.error(err, '', { closeButton: true })
            })
          } else {
            this.refs.container.success('Registro Guardado', '', { closeButton: true })
            setTimeout(() => {
              hashHistory.push('estadoSaludDashboard/' + this.props.params.patient)
            }, 1800)
          }
          this.saving = false
        })
    } else {
      this.refs.container.error('esta guardando aun', '', { closeButton: true })
    }
  }
  presionParadoAltaChange() {
    let arr = this.state.arr
    arr[0] = 'data-input'
    let array = { value: this.refs.paparado.value, position: 0 }
    arr[0] = ValidateParameters(array, true)
    this.setState({
      dirty: true,
      presionParadoAlta: this.refs.paparado.value,
      paclassName: 'medical-inputs'
    })
    if (
      Number(this.refs.paparado.value) > 220 ||
      Number(this.refs.paparado.value) < 90
    ) {
      this.setState({
        ppaText: 'La presión parado alta debe ser un valor entre 90 y 220'
      })
    } else if (isNaN(Number(this.refs.paparado.value))) {
      this.setState({ ppaText: 'debe  s introducir un numero' })
    } else {
      this.setState({ ppaText: '' })
    }
    this.setState({ arr: arr })
  }

  presionParadoBajaChange() {
    let arr = this.state.arr
    arr[1] = 'data-input'
    let array = { value: this.refs.paparado_n.value, position: 1 }
    arr[1] = ValidateParameters(array, true)
    this.setState({ arr: arr })
    this.setState({
      dirty: true,
      presionParadoBaja: this.refs.paparado_n.value
    })
    if (
      Number(this.refs.paparado_n.value) > 120 ||
      Number(this.refs.paparado_n.value) < 60
    ) {
      this.setState({
        ppbText: 'La presión parado baja debe ser un valor entre 60 y 120'
      })
    } else if (isNaN(Number(this.refs.paparado_n.value))) {
      this.setState({ ppbText: 'debes introducir un numero' })
    } else {
      this.setState({ ppbText: '' })
    }
  }

  presionSentadoAltaChange() {
    let arr = this.state.arr
    arr[2] = 'data-input'
    let array = { value: this.refs.psentado.value, position: 2 }
    arr[2] = ValidateParameters(array, true)
    this.setState({ arr: arr })
    this.setState({
      dirty: true,
      presionSentadoAlta: this.refs.psentado.value,
      psclassName: 'medical-inputs'
    })
    if (
      Number(this.refs.psentado.value) > 220 ||
      Number(this.refs.psentado.value) < 90
    ) {
      this.setState({
        psaText: 'La presión sentado alta debe ser un valor entre 90 y 220'
      })
    } else if (isNaN(Number(this.refs.psentado.value))) {
      this.setState({ psaText: 'debes introducir un numero' })
    } else {
      this.setState({ psaText: '' })
    }
  }

  presionSentadoBajaChange() {
    let arr = this.state.arr
    arr[3] = 'data-input'

    let array = { value: this.refs.psentado_n.value, position: 3 }
    arr[3] = ValidateParameters(array, true)
    this.setState({ arr: arr })
    this.setState({
      dirty: true,
      presionSentadoBaja: this.refs.psentado_n.value
    })
    if (
      Number(this.refs.psentado_n.value) > 120 ||
      Number(this.refs.psentado_n.value) < 60
    ) {
      this.setState({
        psbText: 'La presión sentado baja debe ser un valor entre 60 y 120'
      })
    } else if (isNaN(Number(this.refs.psentado_n.value))) {
      this.setState({ psbText: 'debes introducir un numero' })
    } else {
      this.setState({ psbText: '' })
    }
  }

  handleObservaciones() {
    this.setState({ notasText: this.refs.observaciones.value, dirty: true })
  }

  frecuenciaChange() {
    let arr = this.state.arr
    arr[4] = 'data-input'
    let array = { value: this.refs.frecuencia.value, position: 4 }
    arr[4] = ValidateParameters(array, true)
    this.setState({ arr: arr })
    this.setState({ dirty: true, frecuencia: this.refs.frecuencia.value })
    if (
      Number(this.refs.frecuencia.value) > 90 ||
      Number(this.refs.frecuencia.value) < 50
    ) {
      this.setState({
        textFrecuencia: 'La frecuencia debe ser un valor entre 50 y 90 LPM'
      })
    } else if (isNaN(Number(this.refs.frecuencia.value))) {
      this.setState({ textFrecuencia: 'debes introducir un numero' })
    } else {
      this.setState({ textFrecuencia: '' })
    }
  }

  pAbdominalChange() {
    let arr = this.state.arr
    arr[7] = 'data-input'
    let array = { value: this.refs.pabdominal.value, position: 7 }
    arr[7] = ValidateParameters(array, true)
    this.setState({ arr: arr })
    this.setState({ dirty: true, pabdominal: this.refs.pabdominal.value })
  }

  vopChange() {
    let arr = this.state.arr
    arr[12] = 'data-input'
    let array = { value: this.refs.vop.value, position: 12 }
    arr[12] = ValidateParameters(array, true)
    this.setState({ arr: arr })
    this.setState({ dirty: true, vop: this.refs.vop.value })
    if (Number(this.refs.vop.value) > 15 || Number(this.refs.vop.value) < 4) {
      this.setState({ textVOP: 'El vop debe estar entre 4 y 15 ' })
    } else if (isNaN(Number(this.refs.vop.value))) {
      this.setState({ textVOP: 'Debes introducir un numero' })
    } else {
      this.setState({ textVOP: '' })
    }
  }

  itbiChange() {
    let arr = this.state.arr
    arr[10] = 'data-input'
    let array = { value: this.refs.itbi.value, position: 10 }
    arr[10] = ValidateParameters(array, true)
    this.setState({ arr: arr })
    this.setState({ dirty: true, itbi: this.refs.itbi.value })
    if (
      Number(this.refs.itbi.value) > 1.5 ||
      Number(this.refs.itbi.value) < 0.5
    ) {
      this.setState({
        textITBI: 'El itb izquierdo debe estar entre 0.5 y 1.5 '
      })
    } else if (isNaN(Number(this.refs.itbi.value))) {
      this.setState({ textITBI: 'Debes introducir un número' })
    } else {
      this.setState({ textITBI: '' })
    }
  }

  itbdChange() {
    let arr = this.state.arr
    arr[11] = 'data-input'
    let array = { value: this.refs.itbd.value, position: 11 }
    arr[11] = ValidateParameters(array, true)
    this.setState({ arr: arr })
    this.setState({ dirty: true, itbd: this.refs.itbd.value })
    if (
      Number(this.refs.itbd.value) > 1.5 ||
      Number(this.refs.itbd.value) < 0.5
    ) {
      this.setState({ textITBD: 'El itb derecho debe estar entre 0.5 y 1.5 ' })
    } else if (isNaN(Number(this.refs.itbd.value))) {
      this.setState({ textITBD: 'Debes introducir un número' })
    } else {
      this.setState({ textITBD: '' })
    }
  }

  temperaturaChange() {
    let arr = this.state.arr
    arr[14] = 'data-input'
    let array = { value: this.refs.temperatura.value, position: 14 }
    arr[14] = ValidateParameters(array, true)
    this.setState({ arr: arr })
    this.setState({ dirty: true, temperatura: this.refs.temperatura.value })
  }

  pesoChange() {
    let arr = this.state.arr
    arr[5] = 'data-input'
    let array = { value: this.refs.peso.value, position: 5 }
    arr[5] = ValidateParameters(array, true)
    this.setState({ arr: arr })
    let peso = this.refs.peso.value
    let altura = this.refs.altura.value / 100
    let imc = Math.floor(peso / (altura * altura))

    this.setState({ dirty: true, peso: this.refs.peso.value, imc: imc })
    if (
      Number(this.refs.peso.value) > 110 ||
      Number(this.refs.peso.value) < 50
    ) {
      this.setState({ textPeso: 'El peso debe ser un entre 50 y 110 Kg' })
    } else if (isNaN(Number(this.refs.peso.value))) {
      this.setState({ textPeso: 'debes introducir un numero' })
    } else {
      this.setState({ textPeso: '' })
    }
  }

  alturaChange() {
    let arr = this.state.arr
    arr[6] = 'data-input'
    let array = { value: this.refs.altura.value, position: 6 }
    arr[6] = ValidateParameters(array, true)
    this.setState({ arr: arr })
    let peso = this.refs.peso.value
    let altura = this.refs.altura.value / 100
    let imc = Math.floor(peso / (altura * altura))
    this.setState({ dirty: true, altura: this.refs.altura.value, imc: imc })
  }

  balanceNeuroIMuscularChange() {
    let arr = this.state.arr
    arr[8] = 'data-input'
    let array = { value: this.refs.balancen.value, position: 8 }
    arr[8] = ValidateParameters(array, true)
    this.setState({ arr: arr })
    this.setState({
      dirty: true,
      balanceNeuroIMuscular: this.refs.balancen.value
    })
    if (
      Number(this.refs.balancen.value) > 42 ||
      Number(this.refs.balancen.value) < 10
    ) {
      this.setState({
        textBalanceI: 'El balance debe ser un valor entre 10 y 42'
      })
    } else if (isNaN(Number(this.refs.balancen.value))) {
      this.setState({ textBalanceI: 'Debes introducir un numero' })
    } else {
      this.setState({ textBalanceI: '' })
    }
  }
  gripiChange() {
    let arr = this.state.arr
    arr[21] = 'data-input'
    let array = { value: this.refs.gripi.value, position: 21 }
    arr[21] = ValidateParameters(array, true)
    this.setState({ arr: arr })
    this.setState({
      dirty: true,
      gripi: this.refs.gripi.value
    })
  }
  gripdChange() {
    let arr = this.state.arr
    arr[22] = 'data-input'
    let array = { value: this.refs.gripd.value, position: 22 }
    arr[22] = ValidateParameters(array, true)
    this.setState({ arr: arr })
    this.setState({
      dirty: true,
      gripd: this.refs.gripd.value
    })
  }
  balanceNeuroDMuscularChange() {
    let arr = this.state.arr
    arr[9] = 'data-input'
    let array = { value: this.refs.balancend.value, position: 9 }
    arr[9] = ValidateParameters(array, true)
    this.setState({ arr: arr })
    this.setState({
      dirty: true,
      balanceNeuroDMuscular: this.refs.balancend.value
    })
    if (
      Number(this.refs.balancend.value) > 42 ||
      Number(this.refs.balancend.value) < 10
    ) {
      this.setState({
        textBalanceI: 'El balance debe ser un valor entre 10 y 42'
      })
    } else if (isNaN(Number(this.refs.balancend.value))) {
      this.setState({ textBalanceI: 'Debes introducir un numero' })
    } else {
      this.setState({ textBalanceI: '' })
    }
  }

  tiempoCincoMChange() {
    let arr = this.state.arr
    arr[13] = 'data-input'
    let array = { value: this.refs.meters.value, position: 13 }
    arr[13] = ValidateParameters(array, true)
    this.setState({ arr: arr })
    this.setState({ dirty: true, tiempoCincoM: this.refs.meters.value })
  }


  grasaCorporalChange() {
    let arr = this.state.arr
    arr[15] = 'data-input'
    let array = { value: this.refs.grasaCorporal_ref.value, position: 15 }
    arr[15] = ValidateParameters(array, true)
    this.setState({ arr: arr })
    this.setState({ dirty: true, grasaCorporal: this.refs.grasaCorporal_ref.value })
    //console.log("\n STATEeeeeeee \n", this.state)
  }

  healthChange(value) {
    this.setState({ dirty: true, health: value })
  }
  healthInputChange() {
    this.setState({ dirty: true, health: this.refs.health.value })
  }
  unlockData(e) {
    e.preventDefault()
    request
      .post('api/v1/user/unlock')
      .set('Authorization', 'Bearer ' + getToken())
      .send({ password: this.refs.passwordConfirm.value })
      .set('Accept', 'application/json')
      .end((err, res) => {
        if (err || res.status === 500) {
          this.refs.container.error('Contraseña incorrecta', '', {
            closeButton: true
          })
          this.setState({
            incPass: 'Contraseña incorrecta',
            errorMessage: 'error-pass-modal',
            inpErrorClass: 'input-password-confirm-error'
          })
        } else if (res.status === 200) {
          this.refs.container.success('Modo edición habilitado', '', {
            closeButton: true
          })
          this.setState({
            notesUnlockSymbol: unlock,
            positionNotes: '',
            diabeUnlockSymbol: unlock,
            positionDiabetes: '',
            examnUnlockSymbol: unlock,
            positionExamns: '',
            activUnlockSymbol: unlock,
            positionActivity: '',
            emotiUnlockSymbol: unlock,
            positionEmotional: '',
            physiUnlockSymbol: unlock,
            positionPhysical: '',
            basicUnlockSymbol: unlock,
            positionMedical: '',
            disableInputsState: false
          })

          this.refs.passwordData.hide()
        }
      })
  }

  oldFieldsData() { }

  riesgosBooleanToStr(data) {
    if (data === true) {
      return 'Si'
    } else {
      return 'No'
    }
  }

  dashboardRedirect() {
    hashHistory.push('estadoSaludDashboard/' + this.props.params.patient)
  }

  processFunction(elem) {
    let elem_ = elem === undefined || elem === null ? '--' : elem
    return elem_
  }

  getStyle() {
    var profilePicture = this.state.patientImage
      ? this.state.patientImage
      : DefaultPicture
    let styles = {
      img: {
        background: 'url(' + profilePicture + ') center cover no-repeat'
      }
    }
    return Object.assign({}, styles.img)
  }

  loadMedicalControlTabs() {

    request
      .get(`api/v1/estadoSalud/pacienteSort/${this.state.patientId}/relations=[usuarioCreacion]`)
      .set('Authorization', 'Bearer ' + getToken())
      .set('Accept', 'application/json')
      .end((err, res) => {
        if (err || !res.ok) {
          console.log('Error: ', err)
        } else {
          let data = res.body
          this.setState({ all: data })
        }
      })
  }

  cancelFunction(e) {
    e.preventDefault()
    if (this.state.dirty === true) {
      this.refs.container.warning(
        <span className="center-content">
          Tiene cambios pendientes ¿Desea regresar al Dashboard de todos modos?{" "}
          <br />
          <br />
          <span className="email-validation-container">
            <button
              type="button"
              className="btn btn-confirm clear"
              onClick={this.dashboardRedirect.bind(this)}
            >
              Si
            </button>
            <button type="button" className="btn btn-confirm clear">
              No
            </button>
          </span>
        </span>,
        <em>Tiene cambios pendientes</em>,
        {
          closeButton: true,
          showDuration: '300',
          hideDuration: '1000',
          timeOut: 0,
          extendedTimeOut: 0,
          showEasing: 'swing',
          hideEasing: 'linear',
          showMethod: 'fadeIn',
          hideMethod: 'fadeOut'
        }
      )
    } else {
      this.dashboardRedirect()
    }
  }
  showNewControl(e) {
    e.preventDefault()
    if (this.state.control === 'Precontrol') {
      this.setState({ showAddControl: false })
    } else {
      this.setState({ showAddControl: true })
    }
  }

  vlookup(index, table) {
    for (var i = 0, l = table[0].length; i < l; i++) {
      if (index === table[0][i]) return table[1][i]
      if (i < l - 1) {
        if (index > table[0][i] && index < table[0][i + 1]) return table[1][i]
      }
      if (i === l) return table[1][l]
    }
  }

  tabControl(e) {
    e.preventDefault()
    if (e.target.id === 'addControl' || e.target.id === 'addControlP') {
      return false
    }
    if (e.target.id.length < 5) {
      console.log(e.target.id)
      // this.addControll_()
      let res = this.state.all.filter((obj_) => {
        if (e.target.id === obj_._id) return obj_
      })
      console.info("\nRES filtradoo en tabControl (e) \n", res)
      this.lockEdition(res.timestamp, false)
      this.setState({
        programa: res[0]['programa'], prestacion: res[0]['prestacion'], asegurador: res[0]['asegurador'], programaId: res[0]['programaId'], prestacionId: res[0]['prestacionId'], aseguradorId: res[0]['aseguradorId'], presionSentadoBaja: res[0]['diastoleSentado'], presionParadoBaja: res[0]['diastoleParado'], presionSentadoAlta: res[0]['sistoleSentado'], presionParadoAlta: res[0]['sistoleParado'], pabdominal: res[0]['perimetroAbdominal'], balanceNeuroIMuscular: res[0]['balanceNeuroMuscularIzquierdo'], balanceNeuroDMuscular: res[0]['balanceNeuroMuscularDerecho'], itbi: res[0]['itbIzquierdo'], itbd: res[0]['itbDerecho'], imc: res[0]['imc'], vop: res[0]['vop'], notasText: res[0]['notas'], frecuencia: res[0]['frecuencia'], tiempoCincoM: res[0]['tiempoCincoM'], medicalData: res[0], patientGender: res[0]['gender'], peso: res[0]['peso'], altura: res[0]['altura'], patientBirthday: res[0]['fechaNacimiento'], health: res[0]['salud'], temperatura: res[0]['temperatura'],
        grasaCorporal: res[0]['grasaCorporal'],
        patientId: res[0]['paciente']
      })
      return
    }
    let headers = { 'Content-Type': 'application/json' }
    headers['Authorization'] = `Bearer ${getToken()}`
    fetch(`api/v1/estadoSalud/${e.target.id}/relations=[usuarioCreacion,usuarioUltimaModificacion]`, { method: 'Get', headers })
      .then((res) => {
        return res.json()
      }).then((res) => {
        let basicUnlockSymbol
        if (res['_id']) {
          let { currentId } = this.state
          let disableInputsState = true
          if (res['_id'] !== currentId) {
            disableInputsState = true
            this.lockEdition(res.timestamp, true)
          } else {
            disableInputsState = false
            this.lockEdition(res.timestamp, false)
          }
          this.setState({
            programa: res['programa'], prestacion: res['prestacion'], asegurador: res['asegurador'], programaId: res['programaId'], prestacionId: res['prestacionId'], aseguradorId: res['aseguradorId'], presionSentadoBaja: res['diastoleSentado'], presionParadoBaja: res['diastoleParado'], presionSentadoAlta: res['sistoleSentado'], presionParadoAlta: res['sistoleParado'], pabdominal: res['perimetroAbdominal'], balanceNeuroIMuscular: res['balanceNeuroMuscularIzquierdo'], balanceNeuroDMuscular: res['balanceNeuroMuscularDerecho'], itbi: res['itbIzquierdo'], itbd: res['itbDerecho'], imc: res['imc'], vop: res['vop'], notasText: res['notas'], frecuencia: res['frecuencia'], tiempoCincoM: res['tiempoCincoM'], medicalData: res, patientGender: res['gender'], peso: res['peso'], altura: res['altura'], patientBirthday: res['fechaNacimiento'], health: res['salud'], temperatura: res['temperatura'],
            grasaCorporal: res['grasaCorporal'],
            patientId: res['paciente'], disableInputsState, nombrecreador: res['usuarioCreacion']['nombrecompleto'], nombremodificador: res['usuarioUltimaModificacion']['nombrecompleto']
          })
        }
      })

    // let readMode =
    //   scope + 1 === size ? 'health-content hide' : 'health-content'
    // let editionMode =
    //   scope + 1 === size ? 'health-content' : 'health-content hide'
    const processFunction = elem => {
      let elem_ = (elem === undefined) | (elem === null) ? '--' : elem
      return elem_
    }
    const imc = () => {
      try {
        return Math.floor(state[0].peso / Math.pow(state[0].altura / 100, 2))
      } catch (ee) {
        return
      }
    }
    //   let creadoPor = ''
    //   let modificadoPor = ''
    //   console.log(state[0].modificadoPor)
    //   try {
    //       modificadoPor = modificadoPor ? modificadoPor : state[0].modificadoPor
    //       creadoPor = creadoPor ? creadoPor : state[0].modificadoPor
    //       creadoPor = processFunction(state[0].createdBy.nombrecompleto)
    //       modificadoPor = processFunction(state[0].modifiedBy.nombrecompleto)
    //   } catch (e) {
    //       console.log(e)
    //   }
    // var lengthElements = document.getElementsByClassName('tab-control')
    // var i = 0
    // for (i = 0; i < lengthElements.length; i++) {
    //   lengthElements[i].className = 'tab-control'
    // }
    // if (e.target.className === 'tab-control') {
    //   e.target.className = 'tab-control tab-control-selected'
    // }
    // if (e.target.className === 'date') {
    //   e.target.parentNode.className = 'tab-control tab-control-selected'
    // }
    // var balancePerAge = [
    //   [18, 40, 50, 60, 70, 80, 90, 100],
    //   [45, 42, 42, 32, 22, 10, 10, 10]
    // ]
    // var balanceExpected = this.vlookup(this.state.patientAge, balancePerAge)

    // if (imc() >= 20 && imc() < 25) {
    //   this.setState({ IMCRange: 'good-range-text' })
    // } else if (imc() >= 25 && imc() < 30) {
    //   this.setState({ IMCRange: 'regular-range-text' })
    // } else if (imc() < 20 || imc() >= 30) {
    //   this.setState({ IMCRange: 'bad-range-text' })
    // }

    // if (
    //   this.state.patientGender === 'm' &&
    //   Number(state[0].perimetroAbdominal) <= 94
    //   ) {
    //     this.setState({ perAbdRange: 'good-range-text' })
    //   } else if (
    //     this.state.patientGender === 'm' &&
    //     Number(state[0].perimetroAbdominal) > 94
    //     ) {
    //       this.setState({ perAbdRange: 'bad-range-text' })
    //     }

    // if (
    //   this.state.patientGender === 'f' &&
    //   Number(state[0].perimetroAbdominal) <= 82
    // ) {
    //   this.setState({ perAbdRange: 'good-range-text' })
    // } else if (
    //   this.state.patientGender === 'f' &&
    //   Number(state[0].perimetroAbdominal) > 82
    // ) {
    //   this.setState({ perAbdRange: 'bad-range-text' })
    // }

    // if (state[0].itbIzquierdo < 0.9 || state[0].itbIzquierdo > 1.2) {
    //   this.setState({ itbiRange: 'bad-range-text' })
    // } else if (state[0].itbIzquierdo >= 0.9 || state[0].itbIzquierdo <= 1.2) {
    //   this.setState({ itbiRange: 'good-range-text' })
    // }

    // if (state[0].itbDerecho < 0.9 || state[0].itbDerecho > 1.2) {
    //   this.setState({ itbdRange: 'bad-range-text' })
    // } else if (state[0].itbDerecho >= 0.9 || state[0].itbDerecho <= 1.2) {
    //   this.setState({ itbdRange: 'good-range-text' })
    // }

    // if (state[0].vop < 10) {
    //   this.setState({ vopRange: 'good-range-text' })
    // } else if (state[0].vop >= 10) {
    //   this.setState({ vopRange: 'bad-range-text' })
    // }

    // if (Number(state[0].frecuencia) < 50 || Number(state[0].frecuencia) >= 90) {
    //   this.setState({ fcRange: 'bad-range-text' })
    // } else if (
    //   Number(state[0].frecuencia) >= 50 &&
    //   Number(state[0].frecuencia) < 90
    // ) {
    //   this.setState({ fcRange: 'good-range-text' })
    // }

    // if (
    //   Number(state[0].tiempoCincoM) < 50 ||
    //   Number(state[0].tiempoCincoM) >= 90
    // ) {
    //   this.setState({ tiempo: 'bad-range-text' })
    // } else if (
    //   Number(state[0].tiempoCincoM) >= 50 &&
    //   Number(state[0].tiempoCincoM) < 90
    // ) {
    //   this.setState({ tiempo: 'good-range-text' })
    // }

    // if (
    //   Number(state[0].presionParadoAlta) < 120 &&
    //   Number(state[0].presionParadoBaja) < 80
    // ) {
    //   this.setState({ presPRange: 'good-range-text' })
    // } else if (
    //   (Number(state[0].presionParadoAlta) >= 120 &&
    //     Number(state[0].presionParadoAlta) <= 139) ||
    //   (Number(state[0].presionParadoBaja) >= 80 &&
    //     Number(state[0].presionParadoBaja) <= 89)
    // ) {
    //   this.setState({ presPRange: 'regular-range-text' })
    // } else if (
    //   Number(state[0].presionParadoAlta) > 140 &&
    //   Number(state[0].presionParadoBaja) >= 90
    // ) {
    //   this.setState({ presPRange: 'bad-range-text' })
    // }

    // var sistolica =
    //   (parseInt(this.state.presionParadoAlta) +
    //     parseInt(this.state.presionSentadoAlta)) /
    //   2
    // if (Number(sistolica) < 120) {
    //   this.setState({ sistolicaRange: 'good-range-text' })
    // } else if (Number(sistolica) >= 120 && Number(sistolica) <= 139) {
    //   this.setState({ sistolicaRange: 'regular-range-text' })
    // } else if (Number(sistolica) >= 140) {
    //   this.setState({ sistolicaRange: 'bad-range-text' })
    // }

    // if (
    //   Number(state[0].presionSentadoAlta) < 120 &&
    //   Number(state[0].presionSentadoBaja) < 80
    // ) {
    //   this.setState({ presSRange: 'good-range-text' })
    // } else if (
    //   (Number(state[0].presionSentadoAlta) >= 120 &&
    //     Number(state[0].presionSentadoAlta) <= 139) ||
    //   (Number(state[0].presionSentadoBaja) >= 80 &&
    //     Number(state[0].presionSentadoBaja) <= 89)
    // ) {
    //   this.setState({ presSRange: 'regular-range-text' })
    // } else if (
    //   Number(state[0].presionSentadoAlta) >= 140 &&
    //   Number(state[0].presionSentadoBaja) >= 90
    // ) {
    //   this.setState({ presSRange: 'bad-range-text' })
    // }

    // if (state[0].fuma === 'No') {
    //   this.setState({ tabaqRange: 'good-range-text' })
    // } else if (state[0].fuma === 'Si') {
    //   this.setState({ tabaqRange: 'bad-range-text' })
    // }

    // if (state[0].balanceNeuroMuscular < balanceExpected) {
    //   this.setState({ balIzRange: 'bad-range-text' })
    // } else if (state[0].balanceNeuroMuscular >= balanceExpected) {
    //   this.setState({ balIzRange: 'good-range-text' })
    // }

    // if (state[0].balanceNeuroMuscularD < balanceExpected) {
    //   this.setState({ balDeRange: 'bad-range-text' })
    // } else if (state[0].balanceNeuroMuscularD >= balanceExpected) {
    //   this.setState({ balDeRange: 'good-range-text' })
    // }

    // if (state[0].colesterolTotal < 200) {
    //   this.setState({ coltRange: 'good-range-text' })
    // } else if (
    //   state[0].colesterolTotal >= 200 &&
    //   state[0].colesterolTotal <= 270
    // ) {
    //   this.setState({ coltRange: 'regular-range-text' })
    // } else if (state[0].colesterolTotal > 270) {
    //   this.setState({ coltRange: 'bad-range-text' })
    // }

    // if (state[0].trigliceridos < 150) {
    //   this.setState({ trigRange: 'good-range-text' })
    // } else if (state[0].trigliceridos >= 150 && state[0].trigliceridos <= 300) {
    //   this.setState({ trigRange: 'regular-range-text' })
    // } else if (state[0].trigliceridos > 300) {
    //   this.setState({ trigRange: 'bad-range-text' })
    // }

    // if (state[0].colesterolLDL < 100) {
    //   this.setState({ collRange: 'good-range-text' })
    // } else if (state[0].colesterolLDL >= 100 && state[0].colesterolLDL <= 190) {
    //   this.setState({ collRange: 'regular-range-text' })
    // } else if (state[0].colesterolLDL > 190) {
    //   this.setState({ collRange: 'bad-range-text' })
    // }

    // if (state[0].colesterolHDL < 40) {
    //   this.setState({ colhRange: 'bad-range-text' })
    // } else if (state[0].colesterolHDL >= 40 && state[0].colesterolHDL <= 60) {
    //   this.setState({ colhRange: 'regular-range-text' })
    // } else if (state[0].colesterolHDL > 60) {
    //   this.setState({ colhRange: 'good-range-text' })
    // }

    // if (state[0].creatinina < 1.2) {
    //   this.setState({ creatRange: 'good-range-text' })
    // } else if (state[0].creatinina >= 1.2 && state[0].creatinina <= 1.5) {
    //   this.setState({ creatRange: 'regular-range-text' })
    // } else if (state[0].creatinina > 1.5) {
    //   this.setState({ creatRange: 'bad-range-text' })
    // }

    // if (state[0].movilidad === 1) {
    //   this.setState({ movRange: 'color-one-text' })
    // } else if (state[0].movilidad === 2) {
    //   this.setState({ movRange: 'color-two-text' })
    // } else if (state[0].movilidad === 3) {
    //   this.setState({ movRange: 'color-three-text' })
    // }

    // if (state[0].dolor === 1) {
    //   this.setState({ dolRange: 'color-one-text' })
    // } else if (state[0].dolor === 2) {
    //   this.setState({ dolRange: 'color-two-text' })
    // } else if (state[0].dolor === 3) {
    //   this.setState({ dolRange: 'color-three-text' })
    // }

    // if (state[0].cuidadoPersonal === 1) {
    //   this.setState({ cuiRange: 'color-one-text' })
    // } else if (state[0].cuidadoPersonal === 2) {
    //   this.setState({ cuiRange: 'color-two-text' })
    // } else if (state[0].cuidadoPersonal === 3) {
    //   this.setState({ cuiRange: 'color-three-text' })
    // }

    // if (state[0].actividadesCotidianas === 1) {
    //   this.setState({ actRange: 'color-one-text' })
    // } else if (state[0].actividadesCotidianas === 2) {
    //   this.setState({ actRange: 'color-two-text' })
    // } else if (state[0].actividadesCotidianas === 3) {
    //   this.setState({ actRange: 'color-three-text' })
    // }

    // if (state[0].ansiedad === 1) {
    //   this.setState({ ansRange: 'color-one-text' })
    // } else if (state[0].ansiedad === 2) {
    //   this.setState({ ansRange: 'color-two-text' })
    // } else if (state[0].ansiedad === 3) {
    //   this.setState({ ansRange: 'color-three-text' })
    // }

    // if (state[0].mets === 1) {
    //   this.setState({ metsRange: 'color-three-text' })
    // } else if (state[0].mets === 2) {
    //   this.setState({ metsRange: 'color-two-text' })
    // } else if (state[0].mets === 3) {
    //   this.setState({ metsRange: 'color-five-text' })
    // } else if (state[0].mets === 4) {
    //   this.setState({ metsRange: 'color-four-text' })
    // } else if (state[0].mets === 5) {
    //   this.setState({ metsRange: 'color-one-text' })
    // }

    // if (state[0].preocupacion === 1) {
    //   this.setState({ preRange: 'color-one-text' })
    // } else if (state[0].preocupacion === 2) {
    //   this.setState({ preRange: 'color-four-text' })
    // } else if (state[0].preocupacion === 3) {
    //   this.setState({ preRange: 'color-five-text' })
    // } else if (state[0].preocupacion === 4) {
    //   this.setState({ preRange: 'color-two-text' })
    // } else if (state[0].preocupacion === 5) {
    //   this.setState({ preRange: 'color-six-text' })
    // } else if (state[0].preocupacion === 6) {
    //   this.setState({ preRange: 'color-seven-text' })
    // } else if (state[0].preocupacion === 7) {
    //   this.setState({ preRange: 'color-eight-text' })
    // } else if (state[0].preocupacion === 8) {
    //   this.setState({ preRange: 'color-nine-text' })
    // } else if (state[0].preocupacion === 9) {
    //   this.setState({ preRange: 'color-ten-text' })
    // } else if (state[0].preocupacion === 10) {
    //   this.setState({ preRange: 'color-three-text' })
    // }

    // if (state[0].decaido === 1) {
    //   this.setState({ decRange: 'color-one-text' })
    // } else if (state[0].decaido === 2) {
    //   this.setState({ decRange: 'color-four-text' })
    // } else if (state[0].decaido === 3) {
    //   this.setState({ decRange: 'color-five-text' })
    // } else if (state[0].decaido === 4) {
    //   this.setState({ decRange: 'color-two-text' })
    // } else if (state[0].decaido === 5) {
    //   this.setState({ decRange: 'color-six-text' })
    // } else if (state[0].decaido === 6) {
    //   this.setState({ decRange: 'color-seven-text' })
    // } else if (state[0].decaido === 7) {
    //   this.setState({ decRange: 'color-eight-text' })
    // } else if (state[0].decaido === 8) {
    //   this.setState({ decRange: 'color-nine-text' })
    // } else if (state[0].decaido === 9) {
    //   this.setState({ decRange: 'color-ten-text' })
    // } else if (state[0].decaido === 10) {
    //   this.setState({ decRange: 'color-three-text' })
    // }

    // if (state[0].depresion === 10) {
    //   this.setState({ conRange: 'color-one-text' })
    // } else if (state[0].depresion === 9) {
    //   this.setState({ conRange: 'color-four-text' })
    // } else if (state[0].depresion === 8) {
    //   this.setState({ conRange: 'color-five-text' })
    // } else if (state[0].depresion === 7) {
    //   this.setState({ conRange: 'color-two-text' })
    // } else if (state[0].depresion === 6) {
    //   this.setState({ conRange: 'color-six-text' })
    // } else if (state[0].depresion === 5) {
    //   this.setState({ conRange: 'color-seven-text' })
    // } else if (state[0].depresion === 4) {
    //   this.setState({ conRange: 'color-eight-text' })
    // } else if (state[0].depresion === 3) {
    //   this.setState({ conRange: 'color-nine-text' })
    // } else if (state[0].depresion === 2) {
    //   this.setState({ conRange: 'color-ten-text' })
    // } else if (state[0].depresion === 1) {
    //   this.setState({ conRange: 'color-three-text' })
    // }

    // if (state[0].satisfaccion === 10) {
    //   this.setState({ satRange: 'color-one-text' })
    // } else if (state[0].satisfaccion === 9) {
    //   this.setState({ satRange: 'color-four-text' })
    // } else if (state[0].satisfaccion === 8) {
    //   this.setState({ satRange: 'color-five-text' })
    // } else if (state[0].satisfaccion === 7) {
    //   this.setState({ satRange: 'color-two-text' })
    // } else if (state[0].satisfaccion === 6) {
    //   this.setState({ satRange: 'color-six-text' })
    // } else if (state[0].satisfaccion === 5) {
    //   this.setState({ satRange: 'color-seven-text' })
    // } else if (state[0].satisfaccion === 4) {
    //   this.setState({ satRange: 'color-eight-text' })
    // } else if (state[0].satisfaccion === 3) {
    //   this.setState({ satRange: 'color-nine-text' })
    // } else if (state[0].satisfaccion === 2) {
    //   this.setState({ satRange: 'color-ten-text' })
    // } else if (state[0].satisfaccion === 1) {
    //   this.setState({ satRange: 'color-three-text' })
    // }

    // if (state[0].feliz === 10) {
    //   this.setState({ felRange: 'color-one-text' })
    // } else if (state[0].feliz === 9) {
    //   this.setState({ felRange: 'color-four-text' })
    // } else if (state[0].feliz === 8) {
    //   this.setState({ felRange: 'color-five-text' })
    // } else if (state[0].feliz === 7) {
    //   this.setState({ felRange: 'color-two-text' })
    // } else if (state[0].feliz === 6) {
    //   this.setState({ felRange: 'color-six-text' })
    // } else if (state[0].feliz === 5) {
    //   this.setState({ felRange: 'color-seven-text' })
    // } else if (state[0].feliz === 4) {
    //   this.setState({ felRange: 'color-eight-text' })
    // } else if (state[0].feliz === 3) {
    //   this.setState({ felRange: 'color-nine-text' })
    // } else if (state[0].feliz === 2) {
    //   this.setState({ felRange: 'color-ten-text' })
    // } else if (state[0].feliz === 1) {
    //   this.setState({ felRange: 'color-three-text' })
    // }
  }
  exportCsv() {
    this.refs.container.success('Espera se esta generando csv...', '', {
      timeOut: 800,
      closeButton: true
    })
    var url2 = 'api/v1/medical/exportByNumberDocument'
    let identificacion = this.props.params.patient
    request
      .get(url2)
      .query({ numeroDocumento: identificacion })
      .set('Authorization', 'Bearer ' + getToken())
      .set('Accept', 'text/csv')
      .end((err, res) => {
        if (res) {
          var uri =
            'data:text/csv;charset=utf-8,' + encodeURIComponent(res.text)
          window.open(uri, 'pacientes.csv')
          this.refs.container.success('El documento csv se descargo', '', {
            timeOut: 4000,
            closeButton: true
          })
        } else if (err) {
          err
        }
      })
  }
  addControll(e) {
    e.preventDefault()
    //console.warn("Pas apor addControll (e)  ...")
    // this.setState({ showAddControl: false, _id: '', newControl: true })
    if (
      (e.target.id === 'addControl' && this.state.all.length > 0) ||
      (e.target.className === 'plus' && this.state.all.length > 0)
    ) {
      let objs = this.state.all
      let size = this.state.all.length - 1
      let last = objs[size]
      let difftime = moment().diff(
        moment(last.timestamp, 'x').format(),
        'days'
      )
      if (difftime < 30 && difftime >= 0) {
        this.setState({ showModal: true })
      } else {
        console.log('now', moment().format('HH:mm:ss'))
        this.setState({ showModal: false })
        this.addControll_()
      }
    }
  }
  addControll_() {
    //console.warn("\n Entra en  addControll_ () .... " );
    this.setState({ showAddControl: false, _id: '', newControl: true })
    let objs = this.state.all
    let size = this.state.all.length - 1
    let last = objs[size]
    function clone(obj) {
      if (null == obj || 'object' != typeof obj) return obj
      var copy = obj.constructor()
      for (var attr in obj) {
        if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr]
      }
      return copy
    }
    let newobj = clone(last)

    objs.push(newobj)
    delete newobj._id
    newobj._id = String(Math.floor(Math.random() * 10000))
    newobj.timestamp = moment().format('x')
    newobj.actividadesCotidianas = null

    newobj.programa = null
    newobj.programaId = null

    newobj.prestacion = null
    newobj.prestacionId = null

    newobj.asegurador = null
    newobj.aseguradorId = null

    newobj.altura = null
    newobj.ansiedad = null
    newobj.balanceNeuroMuscularDerecho = null
    newobj.balanceNeuroMuscularIzquierdo = null
    newobj.balanceNeuroMuscularT = null
    newobj.cuidadoPersonal = null
    newobj.decaido = null
    newobj.depresion = null
    newobj.diastoleParado = null
    newobj.diastoleSentado = null
    newobj.dolor = null
    newobj.feliz = null
    newobj.frecuencia = null
    newobj.gripT = null
    newobj.gripd = null
    newobj.gripi = null
    newobj.itbDerecho = null
    newobj.itbIzquierdo = null
    newobj.mets = null
    newobj.movilidad = null


    newobj.preocupacion = null
    newobj.salud = null
    newobj.satisfaccion = null

    newobj.temperatura = ''
    newobj.tiempoCincoM = null
    newobj.presionParadoAlta = ''
    newobj.presionParadoBaja = ''
    newobj.presionSentadoAlta = ''
    newobj.presionSentadoBaja = ''
    newobj.frecuencia = null
    newobj.temperatura = null
    newobj.grasaCorporal = null
    newobj.peso = null
    newobj.altura = null
    newobj.funcional = null
    newobj.pabdominal = null
    newobj.vop = null
    newobj.itbi = null
    newobj.itbd = null
    newobj.balanceNeuroIMuscular = null
    newobj.balanceNeuroDMuscular = null
    newobj.gripi = null
    newobj.gripd = null
    newobj.tiempoCincoM = null
    newobj.health = null
    this.lockEdition(newobj.timestamp, false)
    let readMode = 'health-content hide'
    let editionMode = 'health-content'
    try {
      var arr = this.mesesFinish(this.state.meses)
    } catch (e) { }
    arr = []
    for (var e = 0; e < 26; e++) {
      arr.push('data-input red')
    }
    // {_id:'5cec58e00631573619d54a83', name: 'Saludable'},
    let rol = localStorage.rol_name
    let asegurador = rol == 'general sura' ? 'EPS Sura' : ''
    let aseguradorId = rol == 'general sura' ? '57c4955b2171fa5b2490d159' : ''
    let programa = rol == 'general sura' ? 'Saludable' : ''
    let programaId = rol == 'general sura' ? '5cec58e00631573619d54a83' : ''
    let prestacionId = rol == 'general sura' ? '5e6a91e547828d567a2e9002' : ''
    let prestacion = rol == 'general sura' ? 'CF IPS Bello' : ''
    arr[23] = 'data-input '
    arr[24] = 'data-input'
    arr[25] = 'data-input'
    this.setState({
      asegurador,
      aseguradorId,
      prestacion,
      prestacionId,
      programa,
      programaId,
      all: objs,
      presionParadoAlta: 0,
      presionParadoBaja: 0,
      presionSentadoAlta: 0,
      presionSentadoBaja: 0,
      frecuencia: 0,
      temperatura: 0,
      grasaCorporal: 0,
      peso: 0,
      altura: 0,
      funcional: 0,
      pabdominal: 0,
      vop: 0,
      itbi: 0,
      notasText: '',
      itbd: 0,
      balanceNeuroIMuscular: 0,
      balanceNeuroDMuscular: 0,
      gripi: 0,
      gripd: 0,
      tiempoCincoM: 0,
      health: 0,
      arr: arr,
      diabetes: {},
      medicalData: newobj,
      readMode: readMode
    })
    this.findCore2Data()
  }
  closeModal(e) {
    this.setState({ modal: false, overlymain: 'hide' })
  }

  extremeAlert() {
    this.refs.container.error(
      'Por favor remite el paciente a observación ya que el valor ingresado indica que la salud de paciente no es buena',
      '¡El estado de salud del paciente no es bueno!',
      {
        closeButton: true
      }
    )
  }

  duracionDmChange() {
    this.setState({ duracionDm: this.refs.time.value })
    var currentYear = new Date().getFullYear()
    var inputdataType = new RegExp('^\\d{1,2}$')
    if (
      Number(this.refs.time.value) > this.state.patientAge ||
      Number(this.refs.time.value) < 0
    ) {
      this.setState({
        textTime:
          'La duración de la diabetes no puede ser mayor a la edad del paciente',
        timeClass: 'severity-input severity-input-error'
      })
    } else if (inputdataType.test(this.refs.time.value) === false) {
      this.setState({
        textTime: 'Ingrese un número entre 0 y ' + this.state.patientAge,
        timeClass: 'severity-input severity-input-error'
      })
    } else {
      this.setState({ textTime: '', timeClass: 'severity-input' })
    }
  }
  clickBack(e) {
    var url = '/#/tabledata/' + this.props.params.patient
    window.location.href = url
    console.log('e')
  }

  handleCloseModal() {
    this.setState({ showModal: false })
  }
  handleContinueModal() {
    this.setState({ showModal: false })
    this.addControll_()
  }
  mouseOverHandler(e) {
    if (this.state.TIMESTAMP)
      this.setState({ [`className${e.target.id}`]: 'date' })
  }
  mouseOutHandler(e) {
    this.setState({ [`className${e.target.id}`]: 'hide' })
  }
  selectedAsegurador(id, value) {
    let arr = this.state.arr
    arr[25] = 'data-input'
    this.setState({ asegurador: value, aseguradorId: id, dataAsegurador: [], dirty: true })
    this.setState({ arr: arr })
  }
  selectedPrograma(id, value) {
    let arr = this.state.arr
    arr[23] = 'data-input'
    this.setState({ programa: value, programaId: id, dataPrograma: [], dirty: true })
    this.setState({ arr: arr })
  }
  selected(id, value) {
    console.log(id, value)
    let arr = this.state.arr
    arr[24] = 'data-input'
    this.setState({ prestacion: value, prestacionId: id, dataActivity: [], dirty: true })
    this.setState({ arr: arr })
  }
  findAsegurador() {
    let findData = () => {
      let endpoint = 'api/v1/eps/typeahead'
      request
        .get(endpoint)
        .query({ nombre: this.refs.asegurador.value })
        .set('Authorization', `Bearer ${getToken()}`)
        .set('Accept', 'application/json')
        .end((err, res) => {
          this.setState({ dataAsegurador: res.body })
        })
    }
    setTimeout(findData, 500)
    this.setState({
      dirty: true,
      asegurador: this.refs.asegurador.value
    })
  }
  findPrograma() {
    // this.refs.programa.value
    let sea_ = new RegExp(this.refs.programa.value, 'i')
    let original = [
      {_id: '5cec58a60631573619d54a65', name: 'Sin Programa'},
      { _id: '5cec58e00631573619d54a83', name: 'Saludables' },
    ]
    let resultado = original.filter((d) => { if (d.name.match(sea_)) return d })
    this.setState({ dataPrograma: resultado, programa: this.refs.programa.value, dirty: true, })

  }
  findActividad() {
    let findData = () => {
      request
        .get('api/v1/agendamiento/')
        .query({ name: this.refs.prestacion.value })
        .set('Authorization', `Bearer ${getToken()}`)
        .set('Accept', 'application/json')
        .end((err, res) => {
          this.setState({ dataActivity: res.body })
        })
    }
    setTimeout(findData, 500)
    this.setState({
      dirty: true,
      prestacion: this.refs.prestacion.value
    })
  }
  loadDataForm() {
    let arrayDataLabels = []

    let labelsColumnOne = [
      'P.A. parado',
      'P.A. sentado',
      'F.C.',
      'Peso',
      'Altura',
      'IMC',
      'P. Abdominal',
      'B. Neuromuscular',
      'GRIP',
      'ITB',
      'Fuma',
      'VOP',
      'Tiempo 5 m',
      'Temperatura',
      '% grasa corp'
    ]
    let labelsInfoColumnOne = [
      'P.A. Parado',
      'P.A. sentado',
      'F.C.',
      'Peso',
      'Altura',
      'IMC',
      'P. Abdominal',
      'B. Neuromuscular (I / D)',
      'GRIP',
      'ITB (I / D)',
      'VOP',
      'Fuma',
      'Tiempo 5 m',
      'Temperatura',
      '% grasa corp'
    ]
    arrayDataLabels.push({
      labelsColumnOne: labelsColumnOne,
      labelsInfoColumnOne: labelsInfoColumnOne
    })

    return arrayDataLabels
  }

  render() {

    let { _id } = this.state.medicalData
    let { currentId } = this.state
    var rol = this.state.currentRol
    var controlN = this.state.newControl
    var sistolica =
      (parseInt(this.state.presionParadoAlta) +
        parseInt(this.state.presionSentadoAlta)) /
      2
    document.title = 'Información Médica - CORE 3.0'
    var settings = {
      backgroundColor: '#1A3B4E',
      color: '#ffffff',
      width: '50%',
      height: 'auto',
      border: '1px solid #FFFFFF',
      fontSize: '14px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: '1300'
    }
    var tabs

    if (!_.isEmpty(this.state.all)) {
      let arrayElements = this.state.all
      arrayElements
      let tabcurrent = 'tab current'
      let tabC = 'tab'

      tabs = arrayElements.map(function (item, index) {
        if (item._id === _id) {
          tabC = 'tab selected'
          if (_id === currentId) {
            tabcurrent = 'tab current selected'
          } else {
            tabcurrent = 'tab current'
          }
        } else {
          tabC = 'tab'
          tabcurrent = 'tab current'
        }
        let classtab =
          arrayElements.length - 1 == index
            ? tabcurrent
            : tabC
        let name = ' '
        let lastMonth = ''
        if (index >= 1) {
          let timestamp = arrayElements[index - 1].timestamp
          lastMonth = moment(item.timestamp, 'x').diff(
            moment(timestamp, 'x').format(),
            'months'
          )
        }
        if (index >= 1) {
          if (
            rol === 'enfermero' &&
            (item.control != '0') | (item.control != 0) &&
            controlN === true &&
            index === arrayElements.length - 1
          ) {
            name = ' '
          } else if (item.control === 'Precontrol') {
            name = item.control
          } else {
            name = ' '
          }
        }

        let date_ =
          item.timestamp !== null
            ? moment(item.timestamp, 'x').format('DD/MM/YYYY')
            : moment().format('DD-MM-YYYY')
        date_ = lastMonth !== '' ? `${date_} (${lastMonth})` : `${date_} (--)`
        // console.log(that.deleteControl)
        return (
          <div key={`pa${Math.random()}`} className={classtab} id={item._id} ref={item._id}>
            <span key={`date${Math.random()}`} className="date disable">{date_}</span>
            <br />
            <span key={`r3${Math.random()}`} id={item._id} className="date disable">
              &nbsp;
            </span>
          </div>
        )
      })
    }

    var profilePicture = this.state.patientImage
      ? this.state.patientImage
      : DefaultPicture
    var year = new Date().getFullYear()

    let arrayDataLabels = this.loadDataForm()
    const rol_ = localStorage.rol_name
    // [23]
    // [24]
    // [25]
    // this.state.arr
    // console.log("control: ", this.state.control);
    return (
      <div className="medical health">
        <ReactModal
          className="modal-new"
          isOpen={this.state.showModal}
          contentLabel="Minimal Modal Example"
          overlayClassName="Overlay"
        >
          <p className="warning">
            Aun no ha pasado un mes desde que se creo el ultimo control desea
            crear un nuevo control
          </p>
          <div className="allwidth">
            <button
              className="cancelFunction"
              onClick={this.handleCloseModal.bind(this)}
            >
              Cancelar
            </button>
            <button
              className="nextFunction"
              onClick={this.handleContinueModal.bind(this)}
            >
              Continuar
            </button>
          </div>
        </ReactModal>
        <ToastContainer
          toastMessageFactory={ToastMessageFactory}
          ref="container"
          className="toast-top-right"
        />
        <div className="header">
          <NavigationBar dirty={this.state.dirty} />
        </div>
        <div className="main-data-container">
          <div className={this.state.overlymain} />

          <div className="bar" onClick={this.tabControl.bind(this)}>
            {tabs}
            {
              this.state.muerto ? (
                ''
              ) : (
                  <div
                    id="addControl"
                    className="tab"
                    onClick={this.addControll.bind(this)}
                  >
                    Agregar <span id="addControlP" className="plus">+</span>
                  </div>
                )
            }
          </div>
          <div className={this.state.editionMode}>
            <div className="health-control-data base-information">
              <div
                className="health-personal-information"
                onClick={this.cancelFunction.bind(this)}
              >
                <div className="image-container">
                  <img
                    id="photo"
                    className="patient-photo-printable"
                    src={profilePicture}
                  />
                </div>
                <div className="patient-data">
                  <label>{this.state.patientFullName}</label>
                  <label>{this.state.patientIdentificationDoc}</label>
                  <label>
                    Edad: {this.state.patientAge + ' años'}
                    {this.state.patientAge < 25 ||
                      this.state.patientAge > 80 ? (
                        <img className="range-warning-image" src={warningData} />
                      ) : null}
                  </label>
                  {this.state.muerto ? (
                    <label className="dead">Falleció</label>
                  ) : (
                      ''
                    )}
                  {this.state.muerto ? (
                    <label className="date"> {this.state.date_muerte}</label>
                  ) : (
                      ''
                    )}
                </div>
              </div>

              <div className="base-health-data">
                <div
                  className="overly"
                  style={{ position: this.state.positionMedical }}
                />
                <div className="lock-bar">
                  {this.state.basicUnlockSymbol === '' ? (
                    ''
                  ) : (
                      <img
                        src={this.state.basicUnlockSymbol}
                        className="lock-section"
                        onClick={() =>
                          this.state.basicUnlockSymbol === lock
                            ? this.refs.passwordData.show()
                            : ''
                        }
                      />
                    )}
                  <SkyLight
                    dialogStyles={settings}
                    ref="passwordData"
                    hideOnOverlayClicked
                    title="Desbloquear edición de datos"
                  >
                    <p>
                      Ingrese nuevamente su contraseña para desbloquer la
                      edición de los campos. Recuerde que pasadas 24 horas la
                      edición se bloqueará nuevamente.
                    </p>
                    <div className="password-confirm-container">
                      <input
                        className={this.state.inpErrorClass}
                        id="passwordConfirm"
                        ref="passwordConfirm"
                        type="password"
                        placeholder="Contraseña..."
                      />
                      <span className={this.state.errorMessage}>
                        {this.state.incPass}
                      </span>
                      <div
                        className="diabetes-section save-b-section"
                        onClick={this.unlockData.bind(this)}
                      >
                        Desbloquear
                      </div>
                    </div>
                  </SkyLight>
                </div>
                <div className="administrative-data medical-data">
                  <div className="data-label">

                    {rol_ !== 'general sura' ? (

                      <label className="medical-tag">Programa</label>

                    ) : ''}
                    {rol_ !== 'general sura' ? (

                      <label className="medical-tag">Prestación</label>

                    ) : ''}
                    <label className="medical-tag">Asegurador</label>
                  </div>
                  <div className="data-fields">
                    {rol_ !== 'general sura' ? (
                      <div className="medical-form-group-1">
                        <input
                          className={this.state.arr[23]}
                          disabled={this.state.disableInputsState}
                          id="programa"
                          ref="programa"
                          type="text"
                          onMouseOver={this.mouseOverHandler.bind(this)}
                          onMouseOut={this.mouseOutHandler.bind(this)}
                          value={this.state.programa}
                          onChange={this.findPrograma.bind(this)}
                        />
                        <SeudoSelect selected={this.selectedPrograma.bind(this)} data={this.state.dataPrograma} field={'name'}></SeudoSelect>
                      </div>
                    ) : ''}
                    {rol_ !== 'general sura' ? (
                      <div className="medical-form-group-1">
                        <input
                          className={this.state.arr[24]}
                          disabled={this.state.disableInputsState}
                          id="prestacion"
                          ref="prestacion"
                          type="text"
                          value={this.state.prestacion}
                          onMouseOver={this.mouseOverHandler.bind(this)}
                          onMouseOut={this.mouseOutHandler.bind(this)}
                          onChange={this.findActividad.bind(this)}
                        />
                        <SeudoSelect selected={this.selected.bind(this)} data={this.state.dataActivity} field={'name'}></SeudoSelect>
                      </div>
                    ) : ''}
                    <div className="medical-form-group-1">
                      <input
                        className={this.state.arr[25]}
                        disabled={this.state.disableInputsState}
                        id="asegurador"
                        ref="asegurador"
                        type="text"
                        onMouseOver={this.mouseOverHandler.bind(this)}
                        onMouseOut={this.mouseOutHandler.bind(this)}
                        onChange={this.findAsegurador.bind(this)}
                        value={this.state.asegurador}
                      />
                      <SeudoSelect selected={this.selectedAsegurador.bind(this)} data={this.state.dataAsegurador} field={'nombre'}></SeudoSelect>
                    </div>
                  </div>
                </div>
                <div className="medical-data">

                  <div className="data-label">
                    {arrayDataLabels[0].labelsColumnOne.map(label => (
                      <label key={`d${Math.random()}`} className="medical-tag">{label}</label>
                    ))}
                  </div>
                  <div className="data-fields">

                    <div className="medical-form-group">
                      <input
                        className={this.state.arr[0]}
                        disabled={this.state.disableInputsState}
                        id="paparado"
                        ref="paparado"
                        type="number"
                        value={this.state.presionParadoAlta}
                        onMouseOver={this.mouseOverHandler.bind(this)}
                        onMouseOut={this.mouseOutHandler.bind(this)}
                        onChange={this.presionParadoAltaChange.bind(this)}
                      />
                      <span className={this.state.classNamepaparado}>
                        {this.state.TIMESTAMP
                          ? moment(this.state.TIMESTAMP * 1000, '').format(
                            'DD-MM-YYYY'
                          )
                          : ''}
                      </span>
                      <span className="field-separator">/</span>
                      <input
                        className={this.state.arr[1]}
                        disabled={this.state.disableInputsState}
                        id="paparado_n"
                        ref="paparado_n"
                        type="number"
                        value={this.state.presionParadoBaja}
                        onChange={this.presionParadoBajaChange.bind(this)}
                      />
                    </div>
                    <div className="medical-form-group">
                      <input
                        id="psentado"
                        ref="psentado"
                        disabled={this.state.disableInputsState}
                        type="number"
                        className={this.state.arr[2]}
                        value={this.state.presionSentadoAlta}
                        onMouseOver={this.mouseOverHandler.bind(this)}
                        onMouseOut={this.mouseOutHandler.bind(this)}
                        onChange={this.presionSentadoAltaChange.bind(this)}
                      />
                      <span className={this.state.classNamepsentado}>
                        {this.state.TIMESTAMP
                          ? moment(this.state.TIMESTAMP * 1000, '').format(
                            'DD-MM-YYYY'
                          )
                          : ''}
                      </span>
                      <span className="field-separator">/</span>
                      <input
                        id="psentado_n"
                        ref="psentado_n"
                        disabled={this.state.disableInputsState}
                        type="number"
                        className={this.state.arr[3]}
                        value={this.state.presionSentadoBaja}
                        onChange={this.presionSentadoBajaChange.bind(this)}
                      />
                    </div>
                    <div className="medical-form-group">
                      <input
                        id="frecuencia"
                        ref="frecuencia"
                        disabled={this.state.disableInputsState}
                        type="number"
                        className={this.state.arr[4]}
                        value={this.state.frecuencia}
                        onMouseOver={this.mouseOverHandler.bind(this)}
                        onMouseOut={this.mouseOutHandler.bind(this)}
                        onChange={this.frecuenciaChange.bind(this)}
                      />
                      <span className={this.state.classNamefrecuencia}>
                        {this.state.TIMESTAMP
                          ? moment(this.state.TIMESTAMP * 1000, '').format(
                            'DD-MM-YYYY'
                          )
                          : ''}
                      </span>
                      <span className="field-data">LPM</span>
                    </div>
                    <div className="medical-form-group">
                      <input
                        id="peso"
                        ref="peso"
                        type="number"
                        disabled={this.state.disableInputsState}
                        className={this.state.arr[5]}
                        value={this.state.peso}
                        onMouseOver={this.mouseOverHandler.bind(this)}
                        onMouseOut={this.mouseOutHandler.bind(this)}
                        onChange={this.pesoChange.bind(this)}
                      />
                      <span className={this.state.classNamepeso}>
                        {this.state.TIMESTAMP
                          ? moment(this.state.TIMESTAMP * 1000, '').format(
                            'DD-MM-YYYY'
                          )
                          : ''}
                      </span>
                      <span className="field-data">Kg</span>
                    </div>
                    <div className="medical-form-group">
                      <input
                        id="altura"
                        ref="altura"
                        type="number"
                        className={this.state.arr[6]}
                        disabled={this.state.disableInputsState}
                        value={this.state.altura}
                        onMouseOver={this.mouseOverHandler.bind(this)}
                        onMouseOut={this.mouseOutHandler.bind(this)}
                        onChange={this.alturaChange.bind(this)}
                      />
                      <span className={this.state.classNamealtura}>
                        {this.state.TIMESTAMP
                          ? moment(this.state.TIMESTAMP * 1000, '').format(
                            'DD-MM-YYYY'
                          )
                          : ''}
                      </span>
                      <span className="field-data">cm</span>
                    </div>
                    <div className="medical-form-group">
                      <input
                        id="imc"
                        ref="imc"
                        className='data-input'
                        disabled="true"
                        value={this.state.imc}
                      />
                    </div>
                    <div className="medical-form-group">
                      <input
                        id="pabdominal"
                        ref="pabdominal"
                        type="number"
                        disabled={this.state.disableInputsState}
                        className={this.state.arr[7]}
                        value={this.state.pabdominal}
                        onChange={this.pAbdominalChange.bind(this)}
                      />
                      <span className="field-data">cm</span>
                    </div>
                    <div className="medical-form-group">
                      <input
                        id="balancen"
                        ref="balancen"
                        type="number"
                        disabled={this.state.disableInputsState}
                        className={this.state.arr[8]}
                        value={this.state.balanceNeuroIMuscular}
                        onChange={this.balanceNeuroIMuscularChange.bind(this)}
                      />
                      <input
                        id="balancend"
                        ref="balancend"
                        type="number"
                        disabled={this.state.disableInputsState}
                        className={this.state.arr[9]}
                        value={this.state.balanceNeuroDMuscular}
                        onChange={this.balanceNeuroDMuscularChange.bind(this)}
                      />
                    </div>
                    <div className="medical-form-group">
                      <input
                        id="gripi"
                        ref="gripi"
                        type="number"
                        disabled={this.state.disableInputsState}
                        className={this.state.arr[21]}
                        value={this.state.gripi}
                        onChange={this.gripiChange.bind(this)}

                      />
                      <input
                        id="gripd"
                        ref="gripd"
                        type="number"
                        disabled={this.state.disableInputsState}
                        className={this.state.arr[22]}
                        value={this.state.gripd}
                        onChange={this.gripdChange.bind(this)}

                      />
                    </div>
                    <div className="medical-form-group">
                      <input
                        id="itbi"
                        ref="itbi"
                        type="number"
                        disabled={this.state.disableInputsState}
                        className={this.state.arr[10]}
                        value={this.state.itbi}
                        onChange={this.itbiChange.bind(this)}
                      />
                      <input
                        id="itbd"
                        ref="itbd"
                        type="number"
                        disabled={this.state.disableInputsState}
                        className={this.state.arr[11]}
                        value={this.state.itbd}
                        onChange={this.itbdChange.bind(this)}
                      />
                    </div>
                    <div className="medical-form-group">
                      <RadioGroup
                        id="smokegroup"
                        ref="smokegroup"
                        name="smoke-group"
                        selectedValue={
                          this.state.medicalData.fuma
                            ? this.state.medicalData.fuma
                            : this.state.selectedValue
                        }
                        onChange={this.smokeSelection.bind(this)}
                      >
                        {Radio => (
                          <div className="yesno-medical-container">
                            <Radio
                              id="yes"
                              ref="yes"
                              disabled={this.state.disableInputsState}
                              name="smoke-group"
                              type="radio"
                              value="Si"
                              className="yesno-medical-switch-input"
                            />
                            <label
                              htmlFor="yes"
                              className="yesno-medical-switch-label color-bad"
                            >
                              Si
                            </label>
                            <Radio
                              id="no"
                              ref="notinput"
                              disabled={this.state.disableInputsState}
                              name="smoke-group"
                              type="radio"
                              value="No"
                              className="yesno-medical-switch-input"
                            />
                            <label
                              htmlFor="no"
                              className="yesno-medical-switch-label color-good"
                            >
                              No
                            </label>
                          </div>
                        )}
                      </RadioGroup>
                    </div>
                    <div className="medical-form-group">
                      <input
                        id="vop"
                        ref="vop"
                        type="number"
                        disabled={this.state.disableInputsState}
                        className={this.state.arr[12]}
                        value={this.state.vop}
                        onChange={this.vopChange.bind(this)}
                      />
                    </div>
                    <div className="medical-form-group">
                      <input
                        id="meters"
                        ref="meters"
                        type="number"
                        disabled={this.state.disableInputsState}
                        className={this.state.arr[13]}
                        value={this.state.tiempoCincoM}
                        onChange={this.tiempoCincoMChange.bind(this)}
                      />
                    </div>
                    <div className="medical-form-group">
                      <input
                        id="temperatura"
                        ref="temperatura"
                        type="number"
                        disabled={this.state.disableInputsState}
                        className={this.state.arr[14]}
                        value={this.state.temperatura}
                        onChange={this.temperaturaChange.bind(this)}
                      />
                      <span className="field-data">ºC</span>
                    </div>
                    <div className="medical-form-group">
                      <input
                        id="grasaCorporal_ref"
                        ref="grasaCorporal_ref"
                        type="number"
                        disabled={this.state.disableInputsState}
                        className={this.state.arr[15]}
                        value={this.state.grasaCorporal}
                        onChange={this.grasaCorporalChange.bind(this)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="health-control-data emotional-information">
              <div className="emotional-data">
                <div
                  className="overly"
                  style={{ position: this.state.positionEmotional }}
                />
                <div className="lock-bar">
                  {this.state.emotiUnlockSymbol === '' ? (
                    ''
                  ) : (
                      <img
                        src={this.state.emotiUnlockSymbol}
                        className="lock-section"
                        onClick={() =>
                          this.state.emotiUnlockSymbol === lock
                            ? this.refs.passwordData.show()
                            : ''
                        }
                      />
                    )}
                </div>
                <div className="physical-section">
                  <div className="physical-label-container">
                    <div>
                      ¿En general qué tan satisfecho está con su vida hasta
                      ahora?
                    </div>
                  </div>
                  <div className="form-input-container">
                    <RadioGroup
                      id="satisfied"
                      ref="satisfied"
                      name="satisfied-group"
                      selectedValue={
                        this.state.medicalData.satisfaccion
                          ? String(this.state.medicalData.satisfaccion)
                          : this.state.satisfiedSelectedValue
                      }
                      onChange={this.satisfiedSelection.bind(this)}
                    >
                      {Radio => (
                        <div className="medical-feel-container">
                          <Radio
                            id="satisfied-one"
                            ref="satisfied-one"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="1"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="satisfied-one"
                            className="medical-feel-label color-three"
                          >
                            1
                          </label>
                          <Radio
                            id="satisfied-two"
                            ref="satisfied-two"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="2"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="satisfied-two"
                            className="medical-feel-label color-ten"
                          >
                            2
                          </label>
                          <Radio
                            id="satisfied-three"
                            ref="satisfied-three"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="3"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="satisfied-three"
                            className="medical-feel-label color-nine"
                          >
                            3
                          </label>
                          <Radio
                            id="satisfied-four"
                            ref="satisfied-four"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="4"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="satisfied-four"
                            className="medical-feel-label color-eight"
                          >
                            4
                          </label>
                          <Radio
                            id="satisfied-five"
                            ref="satisfied-five"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="5"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="satisfied-five"
                            className="medical-feel-label color-seven"
                          >
                            5
                          </label>
                          <Radio
                            id="satisfied-six"
                            ref="satisfied-six"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="6"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="satisfied-six"
                            className="medical-feel-label color-six"
                          >
                            6
                          </label>
                          <Radio
                            id="satisfied-seven"
                            ref="satisfied-seven"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="7"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="satisfied-seven"
                            className="medical-feel-label color-two"
                          >
                            7
                          </label>
                          <Radio
                            id="satisfied-eight"
                            ref="satisfied-eight"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="8"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="satisfied-eight"
                            className="medical-feel-label color-five"
                          >
                            8
                          </label>
                          <Radio
                            id="satisfied-nine"
                            ref="satisfied-nine"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="9"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="satisfied-nine"
                            className="medical-feel-label color-four"
                          >
                            9
                          </label>
                          <Radio
                            id="satisfied-ten"
                            ref="satisfied-ten"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="10"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="satisfied-ten"
                            className="medical-feel-label color-one"
                          >
                            10
                          </label>
                        </div>
                        /* arrayDataLabels[0].labelsNumber.map((label) =>
                                                    <Radio id={`satisfied-${label.name}`} ref={`satisfied-${label.name}`} disabled={this.state.disableInputsState} type='radio' value={label.number} className='medical-switch-input'/>
                                                    <label htmlFor={`satisfied-${label.name}`} className={`medical-feel-label color-${label.color}`}>{label.number}</label>
                                                ) */
                      )}
                    </RadioGroup>
                  </div>
                </div>
                <img className="image-h-separator" src={HSeparator} />
                <div className="physical-section">
                  <div className="physical-label-container">
                    <div>
                      ¿En general en que medida usted siente que las cosas que
                      hace valen la pena?
                    </div>
                  </div>
                  <div className="form-input-container">
                    <RadioGroup
                      id="feeling"
                      ref="feeling"
                      name="feeling-group"
                      selectedValue={
                        this.state.medicalData.depresion
                          ? String(this.state.medicalData.depresion)
                          : this.state.transcendenceSelectedValue
                      }
                      onChange={this.transcendenceSelection.bind(this)}
                    >
                      {Radio => (
                        <div className="medical-feel-container">
                          <Radio
                            id="feeling-one"
                            ref="feeling-one"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="1"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="feeling-one"
                            className="medical-feel-label color-three"
                          >
                            1
                          </label>
                          <Radio
                            id="feeling-two"
                            ref="feeling-two"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="2"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="feeling-two"
                            className="medical-feel-label color-ten"
                          >
                            2
                          </label>
                          <Radio
                            id="feeling-three"
                            ref="feeling-three"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="3"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="feeling-three"
                            className="medical-feel-label color-nine"
                          >
                            3
                          </label>
                          <Radio
                            id="feeling-four"
                            ref="feeling-four"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="4"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="feeling-four"
                            className="medical-feel-label color-eight"
                          >
                            4
                          </label>
                          <Radio
                            id="feeling-five"
                            ref="feeling-five"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="5"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="feeling-five"
                            className="medical-feel-label color-seven"
                          >
                            5
                          </label>
                          <Radio
                            id="feeling-six"
                            ref="feeling-six"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="6"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="feeling-six"
                            className="medical-feel-label color-six"
                          >
                            6
                          </label>
                          <Radio
                            id="feeling-seven"
                            ref="feeling-seven"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="7"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="feeling-seven"
                            className="medical-feel-label color-two"
                          >
                            7
                          </label>
                          <Radio
                            id="feeling-eight"
                            ref="feeling-eight"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="8"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="feeling-eight"
                            className="medical-feel-label color-five"
                          >
                            8
                          </label>
                          <Radio
                            id="feeling-nine"
                            ref="feeling-nine"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="9"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="feeling-nine"
                            className="medical-feel-label color-four"
                          >
                            9
                          </label>
                          <Radio
                            id="feeling-ten"
                            ref="feeling-ten"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="10"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="feeling-ten"
                            className="medical-feel-label color-one"
                          >
                            10
                          </label>
                        </div>
                      )}
                    </RadioGroup>
                  </div>
                </div>
                <img className="image-h-separator" src={HSeparator} />
                <div className="physical-section">
                  <div className="physical-label-container">
                    <div>¿Estuvo feliz?</div>
                  </div>
                  <div className="form-input-container">
                    <RadioGroup
                      id="happiness"
                      ref="happiness"
                      name="happiness-group"
                      selectedValue={
                        this.state.medicalData.feliz
                          ? String(this.state.medicalData.feliz)
                          : this.state.happinessSelectedValue
                      }
                      onChange={this.happinessSelection.bind(this)}
                    >
                      {Radio => (
                        <div className="medical-feel-container">
                          <Radio
                            id="happiness-one"
                            ref="happiness-one"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="1"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="happiness-one"
                            className="medical-feel-label color-three"
                          >
                            1
                          </label>
                          <Radio
                            id="happiness-two"
                            ref="happiness-two"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="2"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="happiness-two"
                            className="medical-feel-label color-ten"
                          >
                            2
                          </label>
                          <Radio
                            id="happiness-three"
                            ref="happiness-three"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="3"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="happiness-three"
                            className="medical-feel-label color-nine"
                          >
                            3
                          </label>
                          <Radio
                            id="happiness-four"
                            ref="happiness-four"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="4"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="happiness-four"
                            className="medical-feel-label color-eight"
                          >
                            4
                          </label>
                          <Radio
                            id="happiness-five"
                            ref="happiness-five"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="5"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="happiness-five"
                            className="medical-feel-label color-seven"
                          >
                            5
                          </label>
                          <Radio
                            id="happiness-six"
                            ref="happiness-six"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="6"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="happiness-six"
                            className="medical-feel-label color-six"
                          >
                            6
                          </label>
                          <Radio
                            id="happiness-seven"
                            ref="happiness-seven"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="7"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="happiness-seven"
                            className="medical-feel-label color-two"
                          >
                            7
                          </label>
                          <Radio
                            id="happiness-eight"
                            ref="happiness-eight"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="8"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="happiness-eight"
                            className="medical-feel-label color-five"
                          >
                            8
                          </label>
                          <Radio
                            id="happiness-nine"
                            ref="happiness-nine"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="9"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="happiness-nine"
                            className="medical-feel-label color-four"
                          >
                            9
                          </label>
                          <Radio
                            id="happiness-ten"
                            ref="happiness-ten"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="10"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="happiness-ten"
                            className="medical-feel-label color-one"
                          >
                            10
                          </label>
                        </div>
                      )}
                    </RadioGroup>
                  </div>
                </div>
                <img className="image-h-separator" src={HSeparator} />
                <div className="physical-section">
                  <div className="physical-label-container">
                    <div>¿Estuvo preocupado(a)?</div>
                  </div>
                  <div className="form-input-container">
                    <RadioGroup
                      id="worried"
                      ref="worried"
                      name="worried-group"
                      selectedValue={
                        this.state.medicalData.preocupacion
                          ? String(this.state.medicalData.preocupacion)
                          : this.state.worriedSelectedValue
                      }
                      onChange={this.worriedSelection.bind(this)}
                    >
                      {Radio => (
                        <div className="medical-feel-container">
                          <Radio
                            id="worried-one"
                            ref="worried-one"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="1"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="worried-one"
                            className="medical-feel-label color-one"
                          >
                            1
                          </label>
                          <Radio
                            id="worried-two"
                            ref="worried-two"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="2"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="worried-two"
                            className="medical-feel-label color-four"
                          >
                            2
                          </label>
                          <Radio
                            id="worried-three"
                            ref="worried-three"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="3"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="worried-three"
                            className="medical-feel-label color-five"
                          >
                            3
                          </label>
                          <Radio
                            id="worried-four"
                            ref="worried-four"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="4"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="worried-four"
                            className="medical-feel-label color-two"
                          >
                            4
                          </label>
                          <Radio
                            id="worried-five"
                            ref="worried-five"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="5"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="worried-five"
                            className="medical-feel-label color-six"
                          >
                            5
                          </label>
                          <Radio
                            id="worried-six"
                            ref="worried-six"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="6"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="worried-six"
                            className="medical-feel-label color-seven"
                          >
                            6
                          </label>
                          <Radio
                            id="worried-seven"
                            ref="worried-seven"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="7"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="worried-seven"
                            className="medical-feel-label color-eight"
                          >
                            7
                          </label>
                          <Radio
                            id="worried-eight"
                            ref="worried-eight"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="8"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="worried-eight"
                            className="medical-feel-label color-nine"
                          >
                            8
                          </label>
                          <Radio
                            id="worried-nine"
                            ref="worried-nine"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="9"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="worried-nine"
                            className="medical-feel-label color-ten"
                          >
                            9
                          </label>
                          <Radio
                            id="worried-ten"
                            ref="worried-ten"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="10"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="worried-ten"
                            className="medical-feel-label color-three"
                          >
                            10
                          </label>
                        </div>
                      )}
                    </RadioGroup>
                  </div>
                </div>
                <img className="image-h-separator" src={HSeparator} />
                <div className="physical-section">
                  <div className="physical-label-container">
                    <div>¿Estuvo decaído(a)?</div>
                  </div>
                  <div className="form-input-container">
                    <RadioGroup
                      id="dec"
                      ref="dec"
                      name="dec-group"
                      selectedValue={
                        this.state.medicalData.decaido
                          ? String(this.state.medicalData.decaido)
                          : this.state.decSelectedValue
                      }
                      onChange={this.decSelection.bind(this)}
                    >
                      {Radio => (
                        <div className="medical-feel-container">
                          <Radio
                            id="dec-one"
                            ref="dec-one"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="1"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="dec-one"
                            className="medical-feel-label color-one"
                          >
                            1
                          </label>
                          <Radio
                            id="dec-two"
                            ref="dec-two"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="2"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="dec-two"
                            className="medical-feel-label color-four"
                          >
                            2
                          </label>
                          <Radio
                            id="dec-three"
                            ref="dec-three"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="3"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="dec-three"
                            className="medical-feel-label color-five"
                          >
                            3
                          </label>
                          <Radio
                            id="dec-four"
                            ref="dec-four"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="4"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="dec-four"
                            className="medical-feel-label color-two"
                          >
                            4
                          </label>
                          <Radio
                            id="dec-five"
                            ref="dec-five"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="5"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="dec-five"
                            className="medical-feel-label color-six"
                          >
                            5
                          </label>
                          <Radio
                            id="dec-six"
                            ref="dec-six"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="6"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="dec-six"
                            className="medical-feel-label color-seven"
                          >
                            6
                          </label>
                          <Radio
                            id="dec-seven"
                            ref="dec-seven"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="7"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="dec-seven"
                            className="medical-feel-label color-eight"
                          >
                            7
                          </label>
                          <Radio
                            id="dec-eight"
                            ref="dec-eight"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="8"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="dec-eight"
                            className="medical-feel-label color-nine"
                          >
                            8
                          </label>
                          <Radio
                            id="dec-nine"
                            ref="dec-nine"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="9"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="dec-nine"
                            className="medical-feel-label color-ten"
                          >
                            9
                          </label>
                          <Radio
                            id="dec-ten"
                            ref="dec-ten"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="10"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="dec-ten"
                            className="medical-feel-label color-three"
                          >
                            10
                          </label>
                        </div>
                      )}
                    </RadioGroup>
                  </div>
                </div>
              </div>
              <div className="activity-data">
                <div
                  className="overly"
                  style={{ position: this.state.positionActivity }}
                />
                <div className="lock-bar">
                  {this.state.activUnlockSymbol === '' ? (
                    ''
                  ) : (
                      <img
                        src={this.state.activUnlockSymbol}
                        className="lock-section"
                        onClick={() =>
                          this.state.activUnlockSymbol === lock
                            ? this.refs.passwordData.show()
                            : ''
                        }
                      />
                    )}
                </div>
                <div className="physical-section">
                  <div className="physical-label-container">
                    <div>
                      Elija la categoría que mejor describe su rutina cotidiana
                      de actividad física
                    </div>
                  </div>
                  <div className="physical-component-field">
                    <RadioGroup
                      id="phy"
                      ref="phy"
                      name="phy-group"
                      selectedValue={
                        this.state.medicalData.mets
                          ? String(this.state.medicalData.mets)
                          : this.state.phySelectedValue
                      }
                      onChange={this.phySelection.bind(this)}
                    >
                      {Radio => (
                        <div className="medical-switch-container">
                          <Radio
                            id="phy-one"
                            ref="phy-one"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="1"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="phy-one"
                            className="medical-switch-label color-three"
                          >
                            1
                          </label>
                          <Radio
                            id="phy-two"
                            ref="phy-two"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="2"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="phy-two"
                            className="medical-switch-label color-two"
                          >
                            2
                          </label>
                          <Radio
                            id="phy-three"
                            ref="phy-three"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="3"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="phy-three"
                            className="medical-switch-label color-five"
                          >
                            3
                          </label>
                          <Radio
                            id="phy-four"
                            ref="phy-four"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="4"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="phy-four"
                            className="medical-switch-label color-four"
                          >
                            4
                          </label>
                          <Radio
                            id="phy-five"
                            ref="phy-five"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="5"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="phy-five"
                            className="medical-switch-label color-one"
                          >
                            5
                          </label>
                        </div>
                      )}
                    </RadioGroup>
                  </div>
                  <div className="emotional-state">{this.state.phyText}</div>
                </div>
              </div>
            </div>
            <div className="health-control-data movility-information">
              <div
                className="overly"
                style={{ position: this.state.positionPhysical }}
              />
              <div className="lock-bar">
                {this.state.physiUnlockSymbol === '' ? (
                  ''
                ) : (
                    <img
                      src={this.state.physiUnlockSymbol}
                      className="lock-section"
                      onClick={() =>
                        this.state.physiUnlockSymbol === lock
                          ? this.refs.passwordData.show()
                          : ''
                      }
                    />
                  )}
              </div>
              <div className="data-form patient-emotion-data">
                <div className="emotional-fields-container">
                  <div className="emotional-field">
                    <div className="form-group-emotional">
                      <div className="emotional-container-label">Movilidad</div>
                      <div className="emotional-component-field">
                        <RadioGroup
                          id="mov"
                          ref="mov"
                          name="mov-group"
                          selectedValue={
                            this.state.medicalData.movilidad
                              ? String(this.state.medicalData.movilidad)
                              : this.state.movSelectedValue
                          }
                          onChange={this.movSelection.bind(this)}
                        >
                          {Radio => (
                            <div className="medical-switch-container">
                              <Radio
                                id="mov-one"
                                disabled={this.state.disableInputsState}
                                ref="mov-one"
                                name="mov-group"
                                value="1"
                                className="medical-switch-input"
                              />
                              <label
                                htmlFor="mov-one"
                                className="medical-switch-label color-one"
                              >
                                1
                              </label>
                              <Radio
                                id="mov-two"
                                disabled={this.state.disableInputsState}
                                ref="mov-two"
                                name="mov-group"
                                value="2"
                                className="medical-switch-input"
                              />
                              <label
                                htmlFor="mov-two"
                                className="medical-switch-label color-two"
                              >
                                2
                              </label>
                              <Radio
                                id="mov-three"
                                disabled={this.state.disableInputsState}
                                ref="mov-three"
                                name="mov-group"
                                value="3"
                                className="medical-switch-input"
                              />
                              <label
                                htmlFor="mov-three"
                                className="medical-switch-label color-three"
                              >
                                3
                              </label>
                            </div>
                          )}
                        </RadioGroup>
                      </div>
                      <div className="emotional-state">
                        {this.state.movText}
                      </div>
                      <img className="image-h-separator" src={HSeparator} />
                    </div>

                    <div className="form-group-emotional">
                      <div className="emotional-container-label">
                        Cuidado Personal
                      </div>
                      <div className="emotional-component-field">
                        <RadioGroup
                          id="cp"
                          ref="cp"
                          name="cp-group"
                          selectedValue={
                            this.state.medicalData.cuidadoPersonal
                              ? String(this.state.medicalData.cuidadoPersonal)
                              : this.state.cpSelectedValue
                          }
                          onChange={this.cpSelection.bind(this)}
                        >
                          {Radio => (
                            <div className="medical-switch-container">
                              <Radio
                                id="cp-one"
                                ref="cp-one"
                                disabled={this.state.disableInputsState}
                                name="chooser"
                                type="radio"
                                value="1"
                                className="medical-switch-input"
                              />
                              <label
                                htmlFor="cp-one"
                                className="medical-switch-label color-one"
                              >
                                1
                              </label>
                              <Radio
                                id="cp-two"
                                ref="cp-two"
                                name="chooser"
                                disabled={this.state.disableInputsState}
                                type="radio"
                                value="2"
                                className="medical-switch-input"
                              />
                              <label
                                htmlFor="cp-two"
                                className="medical-switch-label color-two"
                              >
                                2
                              </label>
                              <Radio
                                id="cp-three"
                                ref="cp-three"
                                disabled={this.state.disableInputsState}
                                name="chooser"
                                type="radio"
                                value="3"
                                className="medical-switch-input"
                              />
                              <label
                                htmlFor="cp-three"
                                className="medical-switch-label color-three"
                              >
                                3
                              </label>
                            </div>
                          )}
                        </RadioGroup>
                      </div>
                      <div className="emotional-state">{this.state.cpText}</div>
                      <img className="image-h-separator" src={HSeparator} />
                    </div>

                    <div className="form-group-emotional">
                      <div className="emotional-container-label">
                        Actividades Cotidianas
                      </div>
                      <div className="emotional-component-field">
                        <RadioGroup
                          id="actco"
                          ref="actco"
                          name="actco-group"
                          selectedValue={
                            this.state.medicalData.actividadesCotidianas
                              ? String(
                                this.state.medicalData.actividadesCotidianas
                              )
                              : this.state.actcoSelectedValue
                          }
                          onChange={this.actcoSelection.bind(this)}
                        >
                          {Radio => (
                            <div className="medical-switch-container">
                              <Radio
                                id="actco-one"
                                ref="actco-one"
                                disabled={this.state.disableInputsState}
                                name="chooser"
                                type="radio"
                                value="1"
                                className="medical-switch-input"
                              />
                              <label
                                htmlFor="actco-one"
                                className="medical-switch-label color-one"
                              >
                                1
                              </label>
                              <Radio
                                id="actco-two"
                                ref="actco-two"
                                disabled={this.state.disableInputsState}
                                name="chooser"
                                type="radio"
                                value="2"
                                className="medical-switch-input"
                              />
                              <label
                                htmlFor="actco-two"
                                className="medical-switch-label color-two"
                              >
                                2
                              </label>
                              <Radio
                                id="actco-three"
                                ref="actco-three"
                                disabled={this.state.disableInputsState}
                                name="chooser"
                                type="radio"
                                value="3"
                                className="medical-switch-input"
                              />
                              <label
                                htmlFor="actco-three"
                                className="medical-switch-label color-three"
                              >
                                3
                              </label>
                            </div>
                          )}
                        </RadioGroup>
                        <div
                          id="resactco"
                          ref="resactco"
                          className="switched-result"
                        />
                      </div>
                      <div className="emotional-state">
                        {this.state.actcoText}
                      </div>
                      <img className="image-h-separator" src={HSeparator} />
                    </div>

                    <div className="form-group-emotional">
                      <div className="emotional-container-label">
                        Dolor / Malestar
                      </div>
                      <div className="emotional-component-field">
                        <RadioGroup
                          id="dm"
                          ref="dm"
                          name="dm-group"
                          selectedValue={
                            this.state.medicalData.dolor
                              ? String(this.state.medicalData.dolor)
                              : this.state.dmSelectedValue
                          }
                          onChange={this.dmSelection.bind(this)}
                        >
                          {Radio => (
                            <div className="medical-switch-container">
                              <Radio
                                id="dm-one"
                                ref="dm-two"
                                name="chooser"
                                disabled={this.state.disableInputsState}
                                type="radio"
                                value="1"
                                className="medical-switch-input"
                              />
                              <label
                                htmlFor="dm-one"
                                className="medical-switch-label color-one"
                              >
                                1
                              </label>
                              <Radio
                                id="dm-two"
                                ref="dm-two"
                                name="chooser"
                                disabled={this.state.disableInputsState}
                                type="radio"
                                value="2"
                                className="medical-switch-input"
                              />
                              <label
                                htmlFor="dm-two"
                                className="medical-switch-label color-two"
                              >
                                2
                              </label>
                              <Radio
                                id="dm-three"
                                ref="dm-three"
                                name="chooser"
                                disabled={this.state.disableInputsState}
                                type="radio"
                                value="3"
                                className="medical-switch-input"
                              />
                              <label
                                htmlFor="dm-three"
                                className="medical-switch-label color-three"
                              >
                                3
                              </label>
                            </div>
                          )}
                        </RadioGroup>
                      </div>
                      <div className="emotional-state">{this.state.dmText}</div>
                      <img className="image-h-separator" src={HSeparator} />
                    </div>

                    <div className="form-group-emotional">
                      <div className="emotional-container-label">
                        Ansiedad / Depresión
                      </div>
                      <div className="emotional-component-field">
                        <RadioGroup
                          id="ansdep"
                          ref="ansdep"
                          name="ansdep-group"
                          selectedValue={
                            this.state.medicalData.ansiedad
                              ? String(this.state.medicalData.ansiedad)
                              : this.state.ansdepSelectedValue
                          }
                          onChange={this.ansdepSelection.bind(this)}
                        >
                          {Radio => (
                            <div className="medical-switch-container">
                              <Radio
                                id="ansdep-one"
                                ref="ansdep-one"
                                name="chooser"
                                disabled={this.state.disableInputsState}
                                type="radio"
                                value="1"
                                className="medical-switch-input"
                              />
                              <label
                                htmlFor="ansdep-one"
                                className="medical-switch-label color-one"
                              >
                                1
                              </label>
                              <Radio
                                id="ansdep-two"
                                ref="ansdep-two"
                                name="chooser"
                                disabled={this.state.disableInputsState}
                                type="radio"
                                value="2"
                                className="medical-switch-input"
                              />
                              <label
                                htmlFor="ansdep-two"
                                className="medical-switch-label color-two"
                              >
                                2
                              </label>
                              <Radio
                                id="ansdep-three"
                                ref="ansdep-three"
                                name="chooser"
                                disabled={this.state.disableInputsState}
                                type="radio"
                                value="3"
                                className="medical-switch-input"
                              />
                              <label
                                htmlFor="ansdep-three"
                                className="medical-switch-label color-three"
                              >
                                3
                              </label>
                            </div>
                          )}
                        </RadioGroup>
                      </div>
                      <div className="emotional-state">
                        {this.state.ansdepText}
                      </div>
                      <img className="image-h-separator" src={HSeparator} />
                      <div className="physical-section">
                        <div className="slider-content">
                          <div>Tu estado de salud HOY</div>
                        </div>
                        <div className="form-input-slider-container">
                          <div className="slider">
                            {this.state.disableInputsState ? (null) : (
                              <Rslider
                                value={parseInt(this.state.health)}
                                onChange={this.healthChange.bind(this)}
                                min={1}
                                max={100}
                              />
                            )}
                          </div>
                          <input
                            id="health"
                            ref="health"
                            disabled={this.state.disableInputsState}
                            type="number"
                            className="slider-input-class"
                            value={this.state.health}
                            onChange={this.healthInputChange.bind(this)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="health-control-data medical-information">
              <div className="box-medical-exams-last">
                <div className="medical-exams">
                  <div
                    className="overly"
                    style={{ position: this.state.positionNotes }}
                  />
                  <div className="exam-header">
                    <div className="exam-title">Notas</div>
                    <div className="exam-lock">
                      {this.state.notesUnlockSymbol === '' ? (
                        ''
                      ) : (
                          <img
                            src={this.state.notesUnlockSymbol}
                            className="lock-section"
                            onClick={() =>
                              this.state.notesUnlockSymbol === lock
                                ? this.refs.passwordData.show()
                                : ''
                            }
                          />
                        )}
                    </div>
                  </div>
                  <img className="image-h-separator" src={HSeparator} />
                  <div className="exam-content">

                    <div className="physics-squares-notes">
                      <textarea
                        ref="observaciones"
                        className="notes-area"
                        disabled={this.state.disableInputsState}
                        value={this.state.notasText}
                        onChange={this.handleObservaciones.bind(this)}
                      />
                    </div>
                  </div>
                  <div>
                    {this.state.nombrecreador ? (<div className="health-notes-author"> {` Creado por: ${this.state.nombrecreador}`}</div>) : ('')}
                    {this.state.nombremodificador ? (<div className="health-notes-author"> {` Modificado por: ${this.state.nombremodificador}`}</div>) : ('')}
                  </div>
                  {this.state.muerto || this.state.disableInputsState ? (
                    ''
                  ) : (
                      <div
                        className="diabetes-section save-b-section"
                      >
                        {this.state.medicalData._id && this.state.medicalData._id.length > 4 ? <div className="diabetes-button health-button"
                          onClick={this.updateFunction.bind(this)}
                        >
                          Actualizar
                      </div> : <div className="diabetes-button health-button"
                            onClick={this.saveFunction.bind(this)}
                          >Guardar</div>}
                      </div>
                    )}
                  <div
                    className="diabetes-section save-b-section"
                    onClick={this.cancelFunction.bind(this)}
                  >
                    <div className="diabetes-button back">
                      ⟵ Regresar al Dashboard
                      </div>
                  </div>
                  <div
                    className="diabetes-section save-b-section"
                    onClick={this.goTabla.bind(this)}
                  >
                    <div className="diabetes-button back">
                      Tabla Comparativa
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Health/HealthForm.js